export const common = {
  // Navigation
  'nav.features': 'الميزات',
  'nav.howItWorks': 'كيف يعمل',
  'nav.pricing': 'الأسعار',
  'nav.faq': 'الأسئلة الشائعة',
  'nav.aboutUs': 'من نحن',
  'nav.getStarted': 'ابدأ الآن',

  // About Us Section
  'aboutUs.badge': "من نحن",
  'aboutUs.title': "لماذا وُجد IdeaVerdict",
  'aboutUs.line1': "أي شخص يمكنه أن يحمل فكرة.",
  'aboutUs.line2': "قليل من يعترف أن فكرته لا تصمد.",
  'aboutUs.paragraph1':
    "معظم الأفكار لا تفشل لأن أصحابها افتقروا للشجاعة. تفشل لأن لا أحد قال لهم الحقيقة في الوقت المناسب. IdeaVerdict يسد تلك الفجوة — نمنحك القراءة الصريحة التي لن يقدمها لك أصدقاؤك.",
  'aboutUs.belief1a': "لا نتاجر بالضجيج.",
  'aboutUs.belief1b': "نتاجر بإشارات السوق.",
  'aboutUs.belief2a': "لا نبيع التحفيز.",
  'aboutUs.belief2b': "نبيع قراءة واضحة للطلب والمنافسة والجدوى.",
  'aboutUs.mission1': "مهمتنا ليست أن نُظهر فكرتك بمظهر جيد.",
  'aboutUs.mission2': "مهمتنا أن نخبرك إن كانت كذلك فعلاً.",
  'aboutUs.analysis':
    "يقيّم IdeaVerdict الأفكار وفق ما يهم فعلاً — بنية السوق، الطلب الحقيقي، المنافسة، رأس المال المطلوب، الوقت حتى الإيرادات، والقابلية للتوسع. بلا عاطفة. بلا تفاؤل. تحليل فقط.",
  'aboutUs.failure1': "معظم المشاريع تفشل.",
  'aboutUs.failure2': "ليس لأن أصحابها كانوا غير أكفاء —",
  'aboutUs.failure3': "بل لأن لا أحد عارضهم بقوة كافية، وفي وقت مبكر كافٍ.",
  'aboutUs.clarity': "نحن وُجدنا لنعارض.",
  'aboutUs.value1': "مباشرون.",
  'aboutUs.value2': "صادقون.",
  'aboutUs.value3': "سريعون.",
  'aboutUs.confirm': "إن كانت فكرتك ذات جوهر، ندعمها.",
  'aboutUs.deny': "وإن لم تكن، نقولها لك في وجهك.",
  'aboutUs.noApplause': "لا تصفيق.",
  'aboutUs.noSugarcoating': "لا تلميع.",
  'aboutUs.noTheater': "لا مسرح.",
  'aboutUs.noHype': "الحكم فقط.",
  // Hero Section
  'hero.badge': 'حكم ذكاء اصطناعي في أقل من 60 ثانية',
  'hero.title1': 'لا تبنِ',
  'hero.title2': 'قبل أن تتحقق.',
  'hero.subtitle': 'IdeaVerdict يختبر فكرتك كمستثمر متشكك.',
  'hero.subtitleLine2': 'حكم صادق في ثوانٍ — لا ضجيج، لا مجاملة.',
  'hero.cta': 'احصل على حكمي',
  'hero.ctaSecondary': 'كيف يعمل',
  'hero.stat1Value': '٣٠',
  'hero.stat1Label': 'رصيد لكل طلب',
  'hero.stat2Value': 'من ٧',
  'hero.stat2Label': 'أبعاد التقييم',
  'hero.stat3Value': '١٠٠٪',
  'hero.stat3Label': 'صادق وخاص',

  // Features Section
  'features.title1': 'مصمَّم',
  'features.title2': 'للمؤسسين الذين',
  'features.title3': 'يريدون الحقيقة',
  'features.bullet1.title': 'حكم صادق في ثوانٍ',
  'features.bullet1.description':
    'قوي، مختلط، أو ضعيف — مع الأسباب وراء كل تقييم. لا تصفيق، لا تجميل، لا مسرحية.',
  'features.bullet2.title': 'تقييم على ما يهم فعلًا',
  'features.bullet2.description':
    'تُقيَّم فكرتك بناءً على الطلب الحقيقي والمنافسة ورأس المال المطلوب ووقت تحقيق الإيرادات وقابلية التوسع — لا الانطباعات.',
  'features.bullet3.title': 'من الحكم إلى البناء',
  'features.bullet3.description':
    'يحوّل وضع Builder الفكرة المعتمدة إلى موجز للمطورين: تدفقات المستخدم، الميزات الأساسية، الملاحظات التقنية.',

  // How It Works
  'howItWorks.title': 'كيف يعمل',
  'howItWorks.subtitle': 'أربع خطوات للوضوح بشأن مجال عملك.',
  'howItWorks.step1Title': 'اختر خطة',
  'howItWorks.step1Desc': 'مبتدئ، محترف أو منشئ – حسب عمق المراجعة التي تحتاجها.',
  'howItWorks.step2Title': 'اسأل الذكاء الاصطناعي',
  'howItWorks.step2Desc': 'اطرح أسئلتك حول المجال. كل طلب يكلف ٣٠ رصيداً.',
  'howItWorks.step3Title': 'احصل على حكم صادق',
  'howItWorks.step3Desc': 'يصنف الذكاء الاصطناعي: جيد، متوسط أو سيئ. لا تجميل.',
  'howItWorks.step4Title': 'اتخذ قراراً',
  'howItWorks.step4Desc': 'الآن أنت تعرف ما إذا كان الأمر يستحق المتابعة.',

  // Pricing
  'pricing.title': 'الأسعار',
  'pricing.subtitle': 'اختر الخطة التي تناسب عمق المراجعة التي تريدها.',
  'pricing.monthly': 'شهري',
  'pricing.yearly': 'سنوي',
  'pricing.yearlyDiscount': 'الاشتراك السنوي:',
  'pricing.yearlyDiscountValue': '-٢٠٪ خصم',
  'pricing.perMonth': 'شهرياً',
  'pricing.selectPlan': 'اختر الخطة',
  'pricing.mostPopular': 'الأكثر شهرة',
  'pricing.footer':
    'جميع الأسعار بالفرنك السويسري. يتم خصم الأرصدة فقط مقابل ردود الذكاء الاصطناعي الناجحة.',

  
  // Pricing Features
  'pricing.feature1': 'دردشة مجانية (بدون نموذج)',
  'pricing.feature2': 'منطق السوق وتقييم صادق',
  'pricing.feature3': 'سجل دردشة دائم',
  'pricing.feature4': 'جلسات دردشة متوازية متعددة',
  'pricing.feature5': 'متعدد اللغات بالكامل',
  'pricing.feature6': 'استخدام قائم على الرصيد',
  'pricing.feature7': 'إعادة تعيين شهرية',
  'pricing.feature8': 'تحليل السوق',
  'pricing.feature9': 'ملخص',
  'pricing.feature10': 'نقاط القوة',
  'pricing.feature11': 'نقاط الضعف',
  'pricing.feature12': 'الفرص',
  'pricing.feature13': 'المخاطر',
  'pricing.feature14': 'التوصيات',
  'pricing.feature15': 'تحميل PDF',
  'pricing.feature16': 'لا إحاطات للمطورين',
  'pricing.feature17': 'وضع المنشئ: إحاطات للمطورين',
  'pricing.feature18': 'ملخص منظم',

  // Starter Plan
  'pricing.starter.name': 'مبتدئ',
  'pricing.starter.price': '٣٩.٩٠',
  'pricing.starter.description': 'الوصول إلى دردشة الذكاء الاصطناعي للمجالات',
  'pricing.starter.credits': '٢٬٥٠٠ رصيد شهرياً',
  'pricing.starter.feature1': 'توليد فكرة مجال',
  'pricing.starter.feature2': 'تحسين المجال',
  'pricing.starter.feature3': 'فحص واقع السوق',
  'pricing.starter.feature4': 'تقييم المنافسة',
  'pricing.starter.feature5': 'تقييم الوقت',
  'pricing.starter.feature6': 'حكم صادق',
  'pricing.starter.feature7': 'جلسات خاصة',
  'pricing.starter.feature8': 'السجل والتصدير',

  // Pro Plan
  'pricing.pro.name': 'محترف',
  'pricing.pro.price': '٥٩.٩٠',
  'pricing.pro.description': 'الوصول إلى دردشة الذكاء الاصطناعي للمجالات',
  'pricing.pro.credits': '٥٬٠٠٠ رصيد شهرياً',
  'pricing.pro.feature1': 'جميع ميزات المبتدئ',
  'pricing.pro.feature2': 'المزيد من الأرصدة للمراجعة المكثفة',
  'pricing.pro.feature3': 'اقتراحات التحسين',
  'pricing.pro.feature4': 'مجالات بديلة',
  'pricing.pro.feature5': 'تحليل سوق مفصل',
  'pricing.pro.feature6': 'دعم ذو أولوية',
  'pricing.pro.feature7': 'مرشحات متقدمة',
  'pricing.pro.feature8': 'المفضلة في الجلسات',

  // Builder Plan
  'pricing.builder.name': "بنّاء",
  'pricing.builder.price': '١٩٩',
  'pricing.builder.description': "كل الميزات + وضع البنّاء",
  'pricing.builder.credits': "10,000 رصيد شهرياً",
  'pricing.builder.feature1': 'جميع ميزات المحترف',
  'pricing.builder.feature2': 'طلبات ذكاء اصطناعي غير محدودة',
  'pricing.builder.feature3': 'وضع المنشئ: موجزات المطور',
  'pricing.builder.feature4': 'نظرة عامة منظمة على المشروع',
  'pricing.builder.feature5': 'تدفقات المستخدم والميزات الأساسية',
  'pricing.builder.feature6': 'ملاحظات تقنية',
  'pricing.builder.feature7': 'تحديد ما هو خارج النطاق',
  'pricing.builder.feature8': 'حد معدل الاستخدام العادل',
  'pricing.builder.limitNote': 'حد الاستخدام العادل',
  'pricing.monthlyReset': 'تصفير شهري',

  // Modal
  'pricing.modal.selected': 'تم الاختيار',
  'pricing.modal.comingSoon': 'التسجيل ومعالجة الدفع سيكونان متاحين قريباً.',
  'pricing.modal.patience':
    'نحن نعمل على تزويدك بتجربة آمنة وسلسة. يرجى التحلي بالصبر.',
  'pricing.modal.understood': 'تفهمت',

  // FAQ
  'faq.title': 'الأسئلة الشائعة',
  'faq.subtitle': 'أجوبة صادقة ونقدية.',
  'faq.q1': "ماذا يفعل IdeaVerdict فعلياً؟",
  'faq.a1': "يقيّم فكرتك التجارية على ما يحدد النتائج — الطلب الحقيقي، المنافسة، رأس المال المطلوب، الوقت حتى السوق، والقابلية للتوسع.\nإن صمدت الفكرة، نُريك كيف تشحذها.\nوإن لم تصمد، نقول ذلك أيضاً.",
  'faq.q2': "هل تولّدون أفكاراً أيضاً؟",
  'faq.a2': "نعم — لكن لا اقتراحات عشوائية من العدم.\nالأفكار تأتي من فجوات سوق حقيقية، لا مما يروج هذا الأسبوع.",
  'faq.q3': "هل تطورون نماذج أعمال قائمة؟",
  'faq.a3': "نعم، إن كان هناك ما يستحق التطوير.\nلا نلمّع أفكاراً مكسورة — نقوّي تلك التي لديها أساس.",
  'faq.q4': "كيف تختلفون عن أدوات الذكاء الاصطناعي الأخرى؟",
  'faq.a4': "معظم أدوات الذكاء الاصطناعي تخبرك أن فكرتك رائعة.\nنحن نخبرك إن كانت كذلك فعلاً.\nالفرق: واقعية بدل حماس.",
  'faq.q5': "هل هذا يضمن النجاح؟",
  'faq.a5': "لا.\nنساعدك على تجنب الرهانات السيئة — المخاطرة لا تختفي، لكنك تدخل وعيناك مفتوحتان.",
  'faq.q6': "لمن IdeaVerdict؟",
  'faq.a6': "للمؤسسين قبل الإطلاق.\nللمطورين قبل عطلة المشروع الجانبي.\nللمشغّلين قبل رهانهم التالي.\nللمستثمرين قبل التوقيع.\n\nلكل من يريد وضوحاً قبل الالتزام.",
  'faq.q7': "ماذا لو أردت فقط تأكيداً لفكرتي؟",
  'faq.a7': "فـ IdeaVerdict هو الأداة الخاطئة.\nنقدم قراءة صادقة، لا طمأنينة.",
  'faq.q8': "كم هو صادق التحليل فعلاً؟",
  'faq.a8': "صادق بقدر ما تسمح به البيانات.\nلا نخفف من حكم ضعيف لنوفّر مشاعرك.",
  'faq.q9': "هل يحل هذا محل دراسة سوق حقيقية؟",
  'faq.a9': "لا.\nهذا فحص استراتيجي سريع قبل أن تستثمر — وليس دراسة سوق من 50 صفحة.",
  'faq.q10': "لماذا كل هذه المباشرة؟",
  'faq.a10': "لأن بناء الشيء الخطأ يكلفك أشهراً.\nأما الحكم الصادق فيكلفك دقائق.\n\nنحن نختار الدقائق.",
  // Footer
  'footer.description':
    'IdeaVerdict ليس هنا ليجعلك تشعر بالرضا. هو هنا ليساعدك على اتخاذ القرار الصحيح.',
  'footer.product': 'المنتج',
  'footer.aiAssistant': 'مساعد الذكاء الاصطناعي',
  'footer.howItWorks': 'كيف يعمل',
  'footer.pricing': 'الأسعار',
  'footer.faq': 'الأسئلة الشائعة',
  'footer.legal': 'قانوني',
  'footer.privacy': 'الخصوصية',
  'footer.terms': 'الشروط',
  'footer.imprint': 'بيان النشر',
  'footer.support': 'الدعم',
  'footer.contact': 'اتصل بنا',
  'footer.documentation': 'التوثيق',
  'footer.copyright': '© ٢٠٢٦ IdeaVerdict. جميع الحقوق محفوظة.',

  // AI Assistant
  'aiAssistant.title': 'مساعد الذكاء الاصطناعي للمجالات',
  'aiAssistant.subtitle': 'اسأل عن المجالات',
  'aiAssistant.welcomeMessage':
    'مرحباً! صِف فكرتك أو اسألني عن مجال معين. سأعطيك تقييماً واضحاً وصادقاً.',
  'aiAssistant.demoResponse':
    'هذا عرض توضيحي. للحصول على تقييمات حقيقية من الذكاء الاصطناعي، يرجى التسجيل واختيار خطة.',
  'aiAssistant.placeholder': 'صِف فكرتك...',

  // Header & Sidebar
  'dashboard.header.title': 'لوحة التحكم',
  'dashboard.header.aiAssistant': 'مساعد الذكاء الاصطناعي',
  'header.logout': 'تسجيل الخروج',
  'dashboard.sidebar.overview': 'نظرة عامة',
  'dashboard.sidebar.aiChat': 'مساعد الذكاء الاصطناعي',
  'dashboard.sidebar.newAnalysis': 'مساعد الذكاء الاصطناعي',
  'dashboard.sidebar.history': 'السجل',
  'dashboard.sidebar.credits': 'الأرصدة',
  'dashboard.sidebar.settings': 'الإعدادات',

  // Dashboard Overview
  'dashboard.overview.welcome': 'مرحباً بعودتك، {{name}}',
  'dashboard.overview.subtitle': 'إليك نظرة سريعة على نشاطك',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'الأرصدة المتبقية',
  'dashboard.stats.totalAnalyses': 'إجمالي التحليلات',
  'dashboard.stats.goodRatings': 'التقييمات الإيجابية',
  'dashboard.stats.nextReset': 'موعد التصفير التالي',
  'dashboard.stats.days': 'أيام',

  // Quick Actions
  'dashboard.quickActions.title': 'إجراءات سريعة',
  'dashboard.quickActions.checkNewIdea': 'تحقق من فكرة',
  'dashboard.quickActions.checkNewIdeaDesc': 'تحليل فكرة عمل قائمة',
  'dashboard.quickActions.generateIdea': 'توليد فكرة',
  'dashboard.quickActions.generateIdeaDesc': 'ابحث عن مجال مربح جديد',
  'dashboard.quickActions.builderBriefing': 'موجز المنشئ',
  'dashboard.quickActions.builderBriefingDesc': 'تحويل فكرة إلى موجز جاهز للمطور',
  'dashboard.quickActions.premiumOnly': 'للمنشئ فقط',

  // Chat Header
  'chat.title': 'مساعد الذكاء الاصطناعي للمجالات',
  'chat.subtitle': 'اطرح أسئلة حول المجالات. أقيم بنقد وصدق.',
  'chat.creditsLabel': 'الأرصدة',

  // Chat Welcome
  'chat.welcomeTitle': 'مرحباً في مساعد الذكاء الاصطناعي للمجالات',
  'chat.welcomeDesc': 'صِف فكرتك أو اسأل عن مجال. سأقيمه بصدق: جيد، متوسط أو سيئ.',
  'chat.aiWelcome': 'مرحباً! صِف فكرتك أو اسألني عن مجال معين. سأعطيك تقييماً واضحاً وصادقاً.',

  // Chat Suggestions
  'chat.suggestion1': 'أريد بناء أداة SaaS للمستقلين لإدارة الفواتير. هل هذا مجال جيد؟',
  'chat.suggestion2': 'ابحث لي عن عمل أونلاين بمنافسة قليلة يمكنني بدؤه بـ 500 دولار بدون برمجة.',
  'chat.suggestion3': 'قيّم هذا: تطبيق تخطيط وجبات بالذكاء الاصطناعي للآباء المشغولين مع قيود غذائية.',
  'chat.suggestion4': 'أريد بيع قوالب رقمية على Etsy لأصحاب الأعمال الصغيرة. حلل هذا المجال بصدق.',

  // Chat Actions
  'chat.newConversation': 'محادثة جديدة',
  'chat.today': 'اليوم',
  'chat.yesterday': 'أمس',
  'chat.thisWeek': 'هذا الأسبوع',
  'chat.thisMonth': 'هذا الشهر',
  'chat.older': 'أقدم',
  'chat.messages': 'رسائل',
  'chat.renameConversation': 'إعادة تسمية',
  'chat.deleteConversation': 'حذف',
  'chat.cancel': 'إلغاء',
  'chat.rename': 'إعادة تسمية',
  'chat.delete': 'حذف',
  'chat.favorite': 'أضف إلى المفضلة',
  'chat.unfavorite': 'إزالة من المفضلة',
  'chat.searchSessions': 'البحث في المحادثات...',
  'chat.noResults': 'لم يتم العثور على نتائج',
  'chat.noSessions': 'لا توجد محادثات بعد',
  'chat.enterNewName': 'أدخل اسماً جديداً...',
  'chat.deleteConfirmMessage': 'هل أنت متأكد أنك تريد حذف هذه المحادثة؟ لا يمكن التراجع عن هذا الإجراء.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'اكتب سؤالك... (يكلف ٣٠ رصيداً)',
  'chat.send': 'إرسال',
  'chat.voice': 'تحدث',
  'chat.listeningPlaceholder': 'أنا أستمع... تحدث الآن.',
  'chat.stopListening': 'إيقاف الاستماع',
  'chat.recording': 'جاري التسجيل...',
  'chat.speechNotSupported': 'متصفحك لا يدعم التعرف على الصوت.',
  'chat.microphonePermissionDenied': 'تم رفض الوصول إلى الميكروفون. يرجى السماح بالوصول في إعدادات المتصفح.',
  'chat.errorNotEnoughCredits': 'لا يوجد أرصدة كافية. يرجى ترقية خطتك أو انتظار التصفير التالي.',
  'chat.errorAiFailed': 'فشل رد الذكاء الاصطناعي. لم يتم خصم أي أرصدة.',
  'chat.errorRateLimit': 'طلبات كثيرة جداً. يرجى الانتظار لحظة.',

  // Ratings
  'rating.good': 'جيد',
  'rating.medium': 'متوسط',
  'rating.bad': 'سيئ',

  // Auth Page
  'auth.branding.headline1': 'ليست كل فكرة جيدة.',
  'auth.branding.headline2': 'نحن نخبرك بصدق.',
  'auth.branding.subtitle': 'ذكاء اصطناعي لاتخاذ القرارات للمجالات التجارية. واضح. نقدي. لا تجميل.',
  'auth.benefits.privacy.title': 'خاص بنسبة ١٠٠٪',
  'auth.benefits.privacy.desc': 'أفكارك تبقى خاصة وآمنة تماماً.',
  'auth.benefits.honest.title': 'ذكاء اصطناعي صادق',
  'auth.benefits.honest.desc': 'لا تجميل – فقط ملاحظات واضحة ونقدية.',
  'auth.benefits.fast.title': 'نتائج سريعة',
  'auth.benefits.fast.desc': 'احصل على الوضوح بشأن مجالك في دقائق.',
  'auth.trust.users': 'المستخدمين النشطين',
  'auth.trust.ideas': 'الأفكار التي تم تحليلها',
  'auth.trust.rating': 'تقييم المستخدمين',
  'auth.login.title': 'تسجيل الدخول',
  'auth.login.headline': 'مرحباً بعودتك',
  'auth.login.subtitle': 'سجل الدخول لمواصلة رحلتك.',
  'auth.login.forgotPassword': 'نسيت كلمة المرور؟',
  'auth.login.submit': 'تسجيل الدخول',
  'auth.login.noAccount': 'ليس لديك حساب؟',
  'auth.login.signUp': 'اشترك',
  'auth.register.title': 'التسجيل',
  'auth.register.headline': 'أنشئ حسابك',
  'auth.register.subtitle': 'ابدأ في تحليل أفكار عملك اليوم.',
  'auth.register.submit': 'إنشاء حساب',
  'auth.register.hasAccount': 'لديك حساب بالفعل؟',
  'auth.register.signIn': 'تسجيل الدخول',
  'auth.fields.name': 'الاسم الكامل',
  'auth.fields.email': 'البريد الإلكتروني',
  'auth.fields.password': 'كلمة المرور',
  'auth.fields.confirmPassword': 'تأكيد كلمة المرور',
  'auth.fields.selectPlan': 'اختر خطتك',
  'auth.fields.testCode': 'رمز تسجيل الدخول والاختبار المجاني',
  'auth.placeholders.name': 'أدخل اسمك',
  'auth.placeholders.email': 'أدخل بريدك الإلكتروني',
  'auth.placeholders.password': 'أدخل كلمة المرور',
  'auth.placeholders.confirmPassword': 'تأكيد كلمة المرور',
  'auth.placeholders.testCode': 'أدخل رمز الاختبار',
  'auth.terms.accept': 'أوافق على',
  'auth.terms.terms': 'الشروط والأحكام',
  'auth.privacy.accept': 'أوافق على',
  'auth.privacy.policy': 'سياسة الخصوصية',
  'auth.errors.nameRequired': 'الاسم مطلوب',
  'auth.errors.emailRequired': 'البريد الإلكتروني مطلوب',
  'auth.errors.emailInvalid': 'يرجى إدخال بريد إلكتروني صالح',
  'auth.errors.passwordRequired': 'كلمة المرور مطلوبة',
  'auth.errors.passwordLength': 'يجب أن تتكون كلمة المرور من ٨ أحرف على الأقل',
  'auth.errors.passwordMismatch': 'كلمتا المرور غير متطابقتين',
  'auth.errors.invalidCode': 'رمز غير صالح أو منتهي الصلاحية',
  'auth.errors.registrationCodeOnly': 'هذا الرمز مخصص للتسجيل فقط',
  'auth.errors.verificationFailed': 'خطأ في التحقق من الرمز. يرجى المحاولة مرة أخرى.',
  'auth.loading': 'يرجى الانتظار...',
  'auth.or': 'أو استمر باستخدام',
  'auth.social.google': 'المتابعة باستخدام Google',
  'auth.social.apple': 'المتابعة باستخدام Apple',
  'auth.actions.verify': 'تحقق',
  'auth.testCode.activated': 'تم تفعيل رمز الاختبار!',
  'auth.testCode.days': 'أيام',
  'auth.testCode.months': 'أشهر',
  'auth.testCode.freeAccess': 'وصول مجاني',
  'auth.testCode.credits': 'أرصدة',

  // Email Verification
  'auth.verification.title': 'تحقق من البريد الإلكتروني',
  'auth.verification.headline': 'تفقد صندوق الوارد الخاص بك',
  'auth.verification.subtitle': 'لقد أرسلنا رمز التحقق إلى:',
  'auth.verification.codeLabel': 'رمز التحقق',
  'auth.verification.codePlaceholder': 'أدخل الرمز المكون من ٦ أرقام',
  'auth.verification.submit': 'تحقق من البريد الإلكتروني',
  'auth.verification.resend': 'إعادة إرسال الرمز',
  'auth.verification.resendIn': 'إعادة الإرسال بعد',
  'auth.verification.seconds': 'ثانية',
  'auth.verification.success': 'تم التحقق من البريد الإلكتروني بنجاح!',
  'auth.verification.error': 'رمز غير صالح. يرجى المحاولة مرة أخرى.',
  'auth.verification.expired': 'انتهت صلاحية الرمز. يرجى طلب رمز جديد.',
  'auth.verification.sent': 'تم إرسال رمز جديد!',
  'auth.verification.checkSpam': 'لم تستلمه؟ تحقق من مجلد البريد العشوائي.',

  // Forgot Password
  'auth.forgot.title': 'نسيت كلمة المرور',
  'auth.forgot.headline': 'إعادة تعيين كلمة المرور',
  'auth.forgot.subtitle': 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.',
  'auth.forgot.submit': 'إرسال رابط إعادة التعيين',
  'auth.forgot.backToLogin': 'العودة إلى تسجيل الدخول',
  'auth.forgot.success': 'تم إرسال البريد الإلكتروني!',
  'auth.forgot.successMessage': 'لقد أرسلنا إليك بريداً إلكترونياً يحتوي على تعليمات لإعادة تعيين كلمة المرور.',
  'auth.forgot.checkInbox': 'تحقق من صندوق الوارد الخاص بك',

  // Reset Password
  'auth.reset.title': 'كلمة مرور جديدة',
  'auth.reset.headline': 'تعيين كلمة مرور جديدة',
  'auth.reset.subtitle': 'أدخل كلمة المرور الجديدة.',
  'auth.reset.newPassword': 'كلمة المرور الجديدة',
  'auth.reset.confirmNewPassword': 'تأكيد كلمة المرور الجديدة',
  'auth.reset.submit': 'تغيير كلمة المرور',
  'auth.reset.success': 'تم تغيير كلمة المرور بنجاح!',
  'auth.reset.successMessage': 'يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة.',
  'auth.reset.loginNow': 'تسجيل الدخول الآن',

  // Legal Pages
  'legal.backToAuth': 'العودة إلى تسجيل الدخول',
  'legal.allRightsReserved': 'جميع الحقوق محفوظة.',

  // Terms Page
  'legal.terms.title': 'الشروط والأحكام',
  'legal.terms.lastUpdated': 'آخر تحديث',
  'legal.terms.section1.title': '١. النطاق',
  'legal.terms.section1.content': 'تنطبق هذه الشروط والأحكام على جميع العقود بين NicheFinder (يُشار إليها فيما يلي باسم "المزود") والمستخدم (يُشار إليه فيما يلي باسم "العميل") فيما يتعلق باستخدام منصة تحليل المجالات المدعومة بالذكاء الاصطناعي.',
  'legal.terms.section2.title': '٢. وصف الخدمة',
  'legal.terms.section2.content': 'يقدم المزود منصة تعتمد على الذكاء الاصطناعي تقوم بتحليل وتقييم الأفكار والمجالات التجارية. تشمل الخدمات:',
  'legal.terms.section2.item1': 'تحليل الأفكار التجارية المدعوم بالذكاء الاصطناعي',
  'legal.terms.section2.item2': 'تقييم إمكانات السوق والمنافسة',
  'legal.terms.section2.item3': 'توليد اقتراحات للمجالات',
  'legal.terms.section2.item4': 'إنشاء موجزات للمطورين (باقة المنشئ)',
  'legal.terms.section3.title': '٣. إبرام العقد والتسجيل',
  'legal.terms.section3.content': 'يتم إبرام العقد من خلال التسجيل على المنصة واختيار الباقة. يؤكد العميل:',
  'legal.terms.section3.item1': 'أنه بلغ سن الرشد وأهليته القانونية الكاملة',
  'legal.terms.section3.item2': 'تقديم معلومات صحيحة أثناء التسجيل',
  'legal.terms.section3.item3': 'تخزين بيانات الوصول بشكل آمن',
  'legal.terms.section4.title': '٤. الأرصدة والفواتير',
  'legal.terms.section4.content': 'يعتمد استخدام ميزات الذكاء الاصطناعي على نظام الأرصدة. كل استعلام للذكاء الاصطناعي يكلف ٣٠ رصيداً. يتم خصم الأرصدة فقط عند الحصول على رد ناجح. تنتهي صلاحية الأرصدة غير المستخدمة في نهاية فترة الفوترة ولا يتم استردادها.',
  'legal.terms.section5.title': '٥. إخلاء المسؤولية',
  'legal.terms.section5.content': 'تعمل تقييمات الذكاء الاصطناعي كأدوات مساعدة في اتخاذ القرار فقط ولا تضمن نجاح العمل. المزود غير مسؤول عن القرارات المتخذة بناءً على تحليلات الذكاء الاصطناعي. تبقى المسؤولية عن النية والإهمال الجسيم كما هي.',
  'legal.terms.section6.title': '٦. حماية البيانات والسرية',
  'legal.terms.section6.content': 'يتم التعامل مع جميع الأفكار التجارية المقدمة بسرية تامة وعدم مشاركتها مع أطراف ثالثة. تتم معالجة البيانات الشخصية وفقاً لسياسة الخصوصية الخاصة بنا وقوانين حماية البيانات المعمول بها.',
  'legal.terms.section7.title': '٧. الإنهاء',
  'legal.terms.section7.content': 'يمكن للعميل إلغاء اشتراكه في أي وقت في نهاية فترة الفوترة الحالية. في حالة انتهاك هذه الشروط، يحتفظ المزود بالحق في حظر الوصول إلى المنصة.',
  'legal.terms.section8.title': '٨. أحكام ختامية',
  'legal.terms.section8.content': 'يسري القانون السويسري. مكان الاختصاص هو زيورخ، سويسرا. إذا كانت بعض أحكام هذه الشروط غير صالحة، تظل صحة الأحكام المتبقية unaffected.',
  'legal.terms.contact.title': 'هل لديك أسئلة حول الشروط؟',
  'legal.terms.contact.content': 'إذا كانت لديك أسئلة حول هذه الشروط والأحكام، يرجى الاتصال بنا على:',

  // Privacy Page
  'legal.privacy.title': 'سياسة الخصوصية',
  'legal.privacy.section1.title': '١. جهة التحكم في البيانات',
  'legal.privacy.section1.content': 'جهة التحكم في البيانات لهذا الموقع هي NicheFinder، زيورخ، سويسرا. نأخذ حماية بياناتك الشخصية على محمل الجد ونعامل بياناتك الشخصية بسرية ووفقاً للوائح حماية البيانات القانونية.',
  'legal.privacy.section2.title': '٢. البيانات التي يتم جمعها',
  'legal.privacy.section2.content': 'نقوم بجمع ومعالجة البيانات الشخصية التالية:',
  'legal.privacy.section2.item1': 'بيانات التسجيل: الاسم، البريد الإلكتروني، كلمة المرور (مشفرة)',
  'legal.privacy.section2.item2': 'بيانات الاستخدام: عنوان IP، نوع المتصفح، أوقات الوصول',
  'legal.privacy.section2.item3': 'الأفكار التجارية واستعلامات المجالات (يتم تخزينها بشكل مجهول)',
  'legal.privacy.section2.item4': 'معلومات الدفع (عبر مقدمي خدمات آمنين من جهات خارجية)',
  'legal.privacy.section3.title': '٣. الغرض من معالجة البيانات',
  'legal.privacy.section3.content': 'تُستخدم بياناتك للأغراض التالية:',
  'legal.privacy.section3.item1': 'توفير وتحسين خدمات الذكاء الاصطناعي لدينا',
  'legal.privacy.section3.item2': 'إدارة الحساب والمصادقة',
  'legal.privacy.section3.item3': 'إصدار الفواتير ومعالجة المدفوعات',
  'legal.privacy.section4.title': '٤. أمان البيانات',
  'legal.privacy.section4.content': 'نحن نطبق تدابير أمنية تقنية وتنظيمية لحماية بياناتك من التلاعب أو الفقدان أو التدمير أو الوصول غير المصرح به. يتم تشفير جميع عمليات نقل البيانات عبر SSL/TLS.',
  'legal.privacy.section5.title': '٥. سرية أفكارك التجارية',
  'legal.privacy.section5.content': 'يتم التعامل مع أفكارك التجارية واستعلامات المجالات المقدمة بسرية تامة. لا يتم مشاركتها مع أطراف ثالثة، ولا تستخدم لأغراض التدريب، ويمكن حذفها بالكامل عند الطلب. أفكارك ملك لك.',
  'legal.privacy.section6.title': '٦. حقوقك',
  'legal.privacy.section6.content': 'لديك الحقوق التالية فيما يتعلق ببياناتك الشخصية:',
  'legal.privacy.section6.item1': 'الحق في الاطلاع على البيانات المخزنة',
  'legal.privacy.section6.item2': 'الحق في تصحيح البيانات غير الدقيقة',
  'legal.privacy.section6.item3': 'الحق في حذف بياناتك',
  'legal.privacy.section6.item4': 'الحق في نقل البيانات',
  'legal.privacy.section7.title': '٧. ملفات تعريف الارتباط (كوكيز)',
  'legal.privacy.section7.content': 'يستخدم موقعنا فقط ملفات تعريف الارتباط الضرورية تقنياً للمصادقة وإدارة الجلسة. نحن لا نستخدم ملفات تعريف ارتباط للتتبع أو أدوات تحليلات تابعة لجهات خارجية دون موافقتك الصريحة.',
  'legal.privacy.section8.title': '٨. التغييرات على سياسة الخصوصية هذه',
  'legal.privacy.section8.content': 'نحن نتحفظ بالحق في تعديل سياسة الخصوصية هذه للامتثال للمتطلبات القانونية المتغيرة أو عند حدوث تغييرات في الخدمة. يمكن دائماً العثور على النسخة الحالية على هذه الصفحة.',
  'legal.privacy.contact.title': 'هل لديك أسئلة حول الخصوصية؟',
  'legal.privacy.contact.content': 'إذا كانت لديك أسئلة حول معالجة بياناتك الشخصية، يرجى الاتصال بنا على:',

  'auth.passwordStrength.label': 'قوة كلمة المرور',
  'auth.passwordStrength.weak': 'ضعيفة',
  'auth.passwordStrength.medium': 'متوسطة',
  'auth.passwordStrength.strong': 'قوية',
  'auth.passwordStrength.veryStrong': 'قوية جداً',
  'auth.passwordStrength.minLength': 'حد أدنى ٨ أحرف',
  'auth.passwordStrength.uppercase': 'حرف كبير',
  'auth.passwordStrength.number': 'رقم',
  'auth.passwordStrength.special': 'رمز خاص',

  trial: {
    subtitle: 'تجربة مجانية',
    upgrade: 'ترقية الآن',
    creditsRemaining: 'رصيد متبقي',
    inputHint: 'نسخة تجريبية - سجل المحادثات غير متوفر',
    banner: {
      title: 'التجربة لمدة ٧ أيام نشطة',
      remaining: 'تبقى {{days}} أيام',
      credits: 'رصيد متوفر',
      upgradeNow: 'ترقية الآن',
    },
    welcome: {
      title: 'مرحباً في النسخة التجريبية المجانية!',
      desc: 'اختبر مساعد الذكاء الاصطناعي مجاناً لمدة ٧ أيام مع ١٠٠ رصيد. اطرح الأسئلة واكتشف الإمكانيات!',
    },
    info: {
      title: 'قيود النسخة التجريبية',
      credits: '١٠٠ رصيد لمدة ٧ أيام',
      noHistory: 'لا يوجد سجل محادثات',
      noSettings: 'ميزات محدودة',
      upgrade: 'قم بالترقية للحصول على الميزات الكاملة',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'الإعدادات',
  'settings.subtitle': 'إدارة حسابك وتفضيلاتك',
  'settings.backToOverview': 'العودة إلى النظرة العامة',
  'settings.subscriptionLink': 'الاشتراك والفواتير',
  'settings.saved': 'تم حفظ التغييرات بنجاح',
  'settings.changesSaved': 'تم حفظ التغييرات',
  'settings.saveChanges': 'حفظ التغييرات',
  'settings.dataExported': 'تم تصدير البيانات بنجاح',

  // Tabs
  'settings.tabs.profile': 'الملف الشخصي',
  'settings.tabs.preferences': 'التفضيلات',
  'settings.tabs.notifications': 'الإشعارات',
  'settings.tabs.account': 'الحساب والخطة',

  // Profile
  'settings.profile.changePhoto': 'تغيير الصورة',
  'settings.profile.photoHint': 'JPG, PNG أو GIF (بحد أقصى ٢ ميجابايت)',
  'settings.profile.uploading': 'جاري الرفع...',
  'settings.profile.photoUpdated': 'تم تحديث الصورة الشخصية!',
  'settings.profile.name': 'الاسم',
  'settings.profile.email': 'البريد الإلكتروني',
  'settings.profile.phone': 'الهاتف',
  'settings.profile.changePassword': 'تغيير كلمة المرور',
  'settings.profile.currentPassword': 'كلمة المرور الحالية',
  'settings.profile.newPassword': 'كلمة المرور الجديدة',
  'settings.profile.confirmPassword': 'تأكيد كلمة المرور',

  // Preferences
  'settings.preferences.language': 'اللغة',
  'settings.preferences.chooseLanguage': 'اختر اللغة',
  'settings.preferences.timezone': 'المنطقة الزمنية',
  'settings.preferences.currency': 'العملة',

  // Notifications
  'settings.notifications.emailTitle': 'الإشعارات عبر البريد الإلكتروني',
  'settings.notifications.email.analysis': 'اكتمال التحليل',
  'settings.notifications.email.analysisDesc': 'استلام بريد إلكتروني عند اكتمال تحليلك',
  'settings.notifications.email.credits': 'تحديثات الرصيد',
  'settings.notifications.email.creditsDesc': 'إشعارات حول الأرصدة وإعادة التعيين',
  'settings.notifications.email.billing': 'الفواتير والمدفوعات',
  'settings.notifications.email.billingDesc': 'إشعارات حول الفواتير وتغييرات الخطة',
  'settings.notifications.email.newsletter': 'النشرة الإخبارية',
  'settings.notifications.email.newsletterDesc': 'نصائح وتحديثات وميزات جديدة',
  'settings.notifications.pushTitle': 'إشعارات الدفع',
  'settings.notifications.push.analysis': 'اكتمال التحليل',
  'settings.notifications.push.analysisDesc': 'إشعار في المتصفح عند اكتمال التحليل',
  'settings.notifications.push.credits': 'تحذيرات الرصيد',
  'settings.notifications.push.creditsDesc': 'تحذير عندما يكون الرصيد منخفضاً',

  // Account
  'settings.account.currentSubscription': 'الاشتراك الحالي',
  'settings.account.plan': 'الخطة',
  'settings.account.price': 'السعر',
  'settings.account.nextBilling': 'الفواتير التالية',
  'settings.account.manageSubscription': 'إدارة الاشتراك والمدفوعات',
  'settings.account.dataPrivacy': 'البيانات والخصوصية',
  'settings.account.exportData': 'تصدير البيانات',
  'settings.account.deleteAccount': 'حذف الحساب',

  // Delete Modal
  'settings.deleteModal.title': 'هل تريد حذف الحساب؟',
  'settings.deleteModal.subtitle': 'سيتم حذف جميع البيانات بشكل دائم.',
  'settings.deleteModal.warning1': 'سيتم حذف جميع التحليلات والبيانات',
  'settings.deleteModal.warning2': 'سيتم إلغاء الاشتراك النشط فوراً',
  'settings.deleteModal.warning3': 'لا يمكن استرداد الأموال',
  'settings.deleteModal.confirmLabel': 'اكتب "{{word}}" للتأكيد *',
  'settings.deleteModal.cancel': 'إلغاء',
  'settings.deleteModal.confirm': 'حذف الحساب',

  // ─── Subscription & Billing ─────────────────────────────
  'sub.backToOverview': 'العودة إلى النظرة العامة',
  'sub.settings': 'الإعدادات',
  'sub.title': 'الاشتراك والفواتير',
  'sub.subtitle': 'إدارة اشتراكك وطرق الدفع والفواتير',
  'sub.tab.overview': 'نظرة عامة',
  'sub.tab.payment': 'طرق الدفع',
  'sub.tab.billing': 'عنوان الفوترة',
  'sub.tab.history': 'سجل المدفوعات',
  'sub.memberSince': 'عضو منذ',
  'sub.perMonth': 'شهرياً',
  'sub.baseCHF': '(المبلغ الأساسي {{amount}} فرنك سويسري)',
  'sub.nextBilling': 'الفواتير التالية',
  'sub.creditsUsed': 'الأرصدة المستخدمة',
  'sub.paymentMethod': 'طريقة الدفع',
  'sub.creditUsage': 'استخدام الرصيد',
  'sub.changePlan': 'تغيير الخطة',
  'sub.reactivate': 'إعادة التنشيط',
  'sub.cancelSub': 'إلغاء الاشتراك',
  'sub.manageCards': 'إدارة البطاقات',
  'sub.downloadInvoices': 'تنزيل الفواتير',
  'sub.invoicesAvailable': '{{count}} فاتورة متاحة بصيغة PDF',
  'sub.accountSettings': 'إعدادات الحساب',
  'sub.profileNotifications': 'الملف الشخصي والإشعارات والمزيد',
  // Prices in EUR info
  'sub.eurInfo': 'الأسعار معروضة بـ',
  'sub.eurLabel': 'اليورو',
  'sub.eurRate': 'السعر:',
  'sub.currentRate': 'السعر الحالي',
  // Payment Methods
  'sub.savedCards': 'البطاقات المحفوظة',
  'sub.newCard': 'بطاقة جديدة',
  'sub.default': 'افتراضي',
  'sub.setDefault': 'تعيين كافتراضي',
  'sub.validUntil': 'صالح حتى',
  'sub.noCards': 'لا توجد بطاقات محفوظة',
  'sub.addFirstCard': 'إضافة البطاقة الأولى',
  'sub.securePayments': 'مدفوعات آمنة',
  'sub.securePaymentsDesc': 'يتم إرسال جميع بيانات الدفع بشكل مشفر وتخزينها بشكل آمن مع مزود الدفع الخاص بنا. نحن لا نخزن أرقام البطاقات الكاملة.',
  // Billing Address
  'sub.billingAddress': 'عنوان الفوترة',
  'sub.edit': 'تعديل',
  'sub.name': 'الاسم',
  'sub.streetAddress': 'الشارع والرقم',
  'sub.zip': 'الرمز البريدي',
  'sub.city': 'المدينة',
  'sub.country': 'الدولة',
  'sub.address': 'العنوان',
  'sub.save': 'حفظ',
  'sub.cancel': 'إلغاء',
  'sub.country.switzerland': 'سويسرا',
  'sub.country.germany': 'ألمانيا',
  'sub.country.austria': 'النمسا',
  'sub.country.netherlands': 'هولندا',
  'sub.country.belgium': 'بلجيكا',
  // Payment History
  'sub.paymentHistory': 'سجل المدفوعات',
  'sub.allInvoicesPDF': 'تنزيل جميع الفواتير بصيغة PDF مع الشعار',
  'sub.downloadAll': 'تنزيل الكل',
  'sub.eurInvoiceNote': 'يتم إصدار الفواتير دائماً بالفرنك السويسري. مبالغ اليورو المعروضة هي للإشارة فقط.',
  'sub.date': 'التاريخ',
  'sub.description': 'الوصف',
  'sub.net': 'الصافي',
  'sub.vat': 'ضريبة القيمة المضافة',
  'sub.total': 'الإجمالي',
  'sub.status': 'الحالة',
  'sub.pdf': 'PDF',
  'sub.invoices': 'الفواتير',
  'sub.totalAmount': 'المبلغ الإجمالي',
  // Change Plan Modal
  'sub.changePlanTitle': 'تغيير الخطة',
  'sub.current': 'الحالي',
  'sub.month': '/شهر',
  'sub.showLess': 'عرض أقل',
  'sub.showMore': '+{{count}} أكثر',
  'sub.switchPlan': 'تغيير الخطة',
  'sub.eurPriceNote': 'الأسعار معروضة باليورو ({{note}}). تتم الفوترة بالفرنك السويسري.',
  // Cancel Modal
  'sub.cancelTitle': 'هل تريد حقاً إلغاء الاشتراك؟',
  'sub.cancelIrreversible': 'لا يمكن التراجع عن هذا الإجراء.',
  'sub.cancelWarning1': 'ستنتهي صلاحية جميع الأرصدة المتبقية',
  'sub.cancelWarning2': 'الرجوع إلى الخطة المجانية',
  'sub.cancelWarning3': 'فقدان جميع الميزات المميزة',
  'sub.pauseInstead': 'بدلاً من ذلك: إيقاف الاشتراك مؤقتاً؟',
  'sub.pauseDesc': 'أوقف اشتراكك مؤقتاً بدلاً من ذلك واحتفظ ببياناتك.',
  'sub.preferPause': 'أفضل الإيقاف المؤقت',
  'sub.cancelReason': 'سبب الإلغاء',
  'sub.selectReason': 'يرجى الاختيار...',
  'sub.reason.tooExpensive': 'مكلف جداً',
  'sub.reason.notUsing': 'لا أستخدمه بما فيه الكفاية',
  'sub.reason.missingFeatures': 'ميزات مفقودة',
  'sub.reason.foundAlternative': 'وجدت بديلاً',
  'sub.reason.other': 'أخرى',
  'sub.confirmType': 'التأكيد: اكتب "CANCEL" *',
  'sub.cancelNow': 'إلغاء الآن',
  // Add Card Modal
  'sub.addCardTitle': 'إضافة بطاقة جديدة',
  'sub.cardHolder': 'اسم حامل البطاقة *',
  'sub.cardNumber': 'رقم البطاقة *',
  'sub.expiryDate': 'تاريخ الانتهاء *',
  'sub.addCard': 'إضافة بطاقة',
  // Change Card Modal
  'sub.choosePayment': 'اختر طريقة الدفع',
  'sub.active': 'نشط',
  'sub.close': 'إغلاق',
  // Toast messages
  'sub.toast.cancelled': 'تم إلغاء اشتراكك في نهاية فترة الفوترة.',
  'sub.toast.reactivated': 'تم إعادة تنشيط اشتراكك بنجاح!',
  'sub.toast.planChanged': 'تم تغيير الخطة بنجاح إلى {{plan}}!',
  'sub.toast.defaultChanged': 'تم تغيير طريقة الدفع الافتراضية.',
  'sub.toast.cannotDeleteDefault': 'لا يمكن حذف البطاقة الافتراضية.',
  'sub.toast.cardRemoved': 'تمت إزالة البطاقة.',
  'sub.toast.fillAll': 'يرجى ملء جميع الحقول.',
  'sub.toast.cardAdded': 'تمت إضافة البطاقة الجديدة بنجاح!',
  'sub.toast.billingSaved': 'تم حفظ عنوان الفوترة.',
  'sub.toast.invoiceDownloaded': 'تم تنزيل الفاتورة {{id}}!',
  'sub.toast.pdfError': 'خطأ في إنشاء PDF.',
  // Chat interface
  'sub.notEnoughCredits': 'لا يوجد أرصدة كافية',
  'sub.needCredits': 'تحتاج إلى {{count}} رصيد على الأقل لكل سؤال.',
  'sub.creditsLow': 'الأرصدة تنفد',
  'sub.questionsLeft': '{{count}} سؤال ممكن.',
  'sub.plan': 'الخطة',
  'sub.base': 'أساسي',
  'sub.unlimited': 'غير محدود',
  'sub.status.active': 'نشط',
  'sub.status.cancelled': 'ملغى',
  'sub.status.paused': 'متوقف مؤقتاً',
  'sub.invoice': 'فاتورة',
  'sub.from': 'من',
  'sub.to': 'إلى',
  'sub.vatId': 'رقم ضريبة القيمة المضافة',
  'sub.tel': 'هاتف',
  'sub.invoiceDate': 'تاريخ الفاتورة',
  'sub.invoiceNumber': 'رقم الفاتورة',
  'sub.paymentStatus': 'حالة الدفع',
  'sub.creditCard': 'بطاقة ائتمان',
  'sub.quantity': 'الكمية',
  'sub.price': 'السعر',
  'sub.amount': 'المبلغ',
  'sub.subtotal': 'المجموع الفرعي',
  'sub.bank': 'البنك',
  'sub.card': 'البطاقة',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'John Doe',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'لوحة تحكم المشرف',
  'admin.subtitle': 'مركز التحكم',
  'admin.superAdmin': 'مشرف عام',
  'admin.logout': 'تسجيل الخروج',
  'admin.tabs.users': 'إدارة المستخدمين',
  'admin.tabs.downgrades': 'تخفيضات',
  'admin.tabs.tips': 'نصيحة اليوم',
  'admin.tabs.coupons': 'رموز القسيمة',
  'admin.tabs.website': 'محرر الموقع',
  'admin.tabs.ai': 'إعدادات الذكاء الاصطناعي',
  'admin.tabs.transactions': 'سجل المعاملات',
  'admin.tabs.stats': 'الإحصائيات',
  'admin.users.searchPlaceholder': 'البحث عن مستخدمين (البريد الإلكتروني أو الاسم)...',
  'admin.users.manageSubscription': 'إدارة الاشتراك',
  'admin.users.grantFree': 'منح حساب مجاني',
  'admin.users.blockUser': 'حظر المستخدم',
  'admin.users.cancellationPlaceholder': 'لماذا يتم إلغاء الاشتراك؟',
  'admin.users.selectPlan': 'اختر خطة',
  'admin.users.subChanged': 'تم تغيير اشتراك {{name}} إلى {{plan}}',
  'admin.users.noReasonGiven': 'لم يتم تقديم سبب',
  'admin.users.subCancelled': 'تم إلغاء اشتراك {{name}} (صالح حتى {{date}})',
  'admin.users.paused': 'متوقف مؤقتاً',
  'admin.users.subPaused': 'تم إيقاف اشتراك {{name}} مؤقتاً',
  'admin.users.subReactivated': 'تم إعادة تنشيط اشتراك {{name}}',
  'admin.users.freeAccount': 'حساب مجاني',
  'admin.users.blocked': 'محظور',
  'admin.users.cancelledExpiring': 'ملغى (ينتهي)',
  'admin.users.cancelledOn': 'ملغى:',
  'admin.users.endsOn': 'ينتهي:',
  'admin.users.daysRemaining': 'أيام متبقية',
  'admin.users.expired': '(منتهي الصلاحية)',
  'admin.users.total': 'الإجمالي:',
  'admin.users.usersLabel': 'مستخدمين',
  'admin.users.free': 'مجاني',
  'admin.users.block': 'حظر',
  'admin.users.unblock': 'إلغاء الحظر',
  'admin.users.unblockUser': 'إلغاء حظر المستخدم',
  'admin.users.selectAction': 'اختر إجراء',
  'admin.users.cancelSub': 'إلغاء الاشتراك',
  'admin.users.cancelSubDesc': 'الإلغاء في نهاية الشهر',
  'admin.users.pauseSub': 'إيقاف الاشتراك مؤقتاً',
  'admin.users.pauseSubDesc': 'إيقاف مؤقت',
  'admin.users.changePlan': 'تغيير الخطة',
  'admin.users.changePlanDesc': 'التبديل إلى خطة أخرى',
  'admin.users.reactivateSub': 'إعادة تنشيط الاشتراك',
  'admin.users.reactivateDesc': 'التراجع عن الإلغاء',
  'admin.users.alreadyCancelled': 'الاشتراك ملغى بالفعل',
  'admin.users.planLabel': 'الخطة',
  'admin.users.cancellationReasonOpt': 'سبب الإلغاء (اختياري)',
  'admin.users.cancelInfo1': 'سينتهي الاشتراك في',
  'admin.users.cancelInfo2': '(نهاية الشهر). وحتى ذلك الحين، يتمتع المستخدم بإمكانية الوصول الكامل. لا يوجد استرداد.',
  'admin.users.newPlan': 'خطة جديدة',
  'admin.users.warning': 'تحذير',
  'admin.users.blockDesc': 'سيتم تسجيل خروج المستخدم فوراً ولن يتمكن من تسجيل الدخول مرة أخرى. سيتم إنهاء جميع الجلسات النشطة.',
  'admin.users.confirmUnblock': 'تأكيد إلغاء الحظر',
  'admin.users.unblockDesc': 'يمكن للمستخدم تسجيل الدخول مرة أخرى واستخدام جميع الميزات.',
  'admin.users.afterBlock': 'بعد الحظر:',
  'admin.users.afterUnblock': 'بعد إلغاء الحظر:',
  'admin.users.noAccountAccess': 'لا يمكن الوصول إلى الحساب',
  'admin.users.noNewAnalyses': 'لا يمكن إجراء تحليلات جديدة',
  'admin.users.creditsStored': 'تبقى الأرصدة والسجل مخزنة',
  'admin.users.accessRestored': 'تمت استعادة الوصول إلى الحساب',
  'admin.users.allFeaturesAvail': 'جميع الميزات متاحة مرة أخرى',
  'admin.users.creditsPreserved': 'تم الحفاظ على الأرصدة والسجل',
  'admin.users.downgrade': 'تخفيض الخطة',
  'admin.users.grantFreeBtn': 'منح مجاني',
  'admin.users.durationMonths': 'المدة (شهور)',
  'admin.users.months': 'شهر(شهور)',
  'admin.users.freePlan': 'مجاني',
  'admin.users.freeSummary': 'يحصل على',
  'admin.users.withCredits': 'مع',
  'admin.users.credits': 'أرصدة',
  'admin.users.subInfo': 'معلومات الاشتراك',
  'admin.users.currentPlan': 'الخطة الحالية',
  'admin.users.joined': 'انضم في',
  'admin.users.totalSpent': 'إجمالي الإنفاق',
  'admin.users.paymentMethod': 'طريقة الدفع',
  'admin.users.validThrough': 'صالح حتى',
  'admin.users.billingAddress': 'عنوان الفوترة',
  'admin.users.transactionHistory': 'سجل المعاملات',
  'admin.users.cancellationDate': 'تاريخ الإلغاء',
  'admin.users.validUntil': 'صالح حتى (نهاية الشهر)',
  'admin.users.cancellationReason': 'سبب الإلغاء',
  'admin.users.noReason': 'لم يتم تقديم سبب',
  'admin.users.timeRemaining': 'الوقت المتبقي',
  'admin.users.daysUntilDeactivation': 'أيام حتى إلغاء التنشيط',
  'admin.table.user': 'المستخدم',
  'admin.table.plan': 'الخطة',
  'admin.table.subStatus': 'حالة الاشتراك',
  'admin.table.cancellation': 'الإلغاء',
  'admin.table.payment': 'طريقة الدفع',
  'admin.table.spending': 'الإنفاق',
  'admin.table.actions': 'الإجراءات',
  'admin.actions.viewDetails': 'عرض التفاصيل',
  'admin.actions.manageSubscription': 'إدارة الاشتراك',
  'admin.actions.grantFree': 'منح وصول مجاني',
  'admin.actions.block': 'حظر المستخدم',
  'admin.actions.unblock': 'إلغاء حظر المستخدم',
  'admin.actions.cancel': 'إلغاء',
  'admin.actions.save': 'حفظ',
  'admin.actions.delete': 'حذف',
  'admin.actions.confirm': 'تأكيد',
  'admin.actions.done': 'تم',
  'admin.actions.edit': 'تعديل',
  'admin.actions.close': 'إغلاق',
  'admin.table.status': 'الحالة',
  'admin.filter.all': 'الكل',
  'admin.subscription.active': 'نشط',
  'admin.subscription.cancelled': 'ملغى',
  'admin.subscription.paused': 'متوقف مؤقتاً',
  'admin.subscription.unknown': 'غير معروف',
  'admin.status.active': 'نشط',
  'admin.status.inactive': 'غير نشط',
  'admin.status.pending': 'قيد الانتظار',
  'admin.status.approved': 'تمت الموافقة',
  'admin.status.rejected': 'مرفوض',
  'admin.coupons.title': 'إدارة القسائم',
  'admin.coupons.subtitle': 'إنشاء وإدارة رموز القسائم',
  'admin.coupons.newCoupon': 'قسيمة جديدة',
  'admin.coupons.registrationCoupons': 'قسائم التسجيل',
  'admin.coupons.trialCoupons': 'قسائم الوصول التجريبي',
  'admin.coupons.type': 'النوع',
  'admin.coupons.plan': 'الخطة',
  'admin.coupons.value': 'القيمة',
  'admin.coupons.usage': 'الاستخدام',
  'admin.coupons.validUntil': 'صالح حتى',
  'admin.coupons.created': 'تم الإنشاء',
  'admin.coupons.actions': 'الإجراءات',
  'admin.coupons.copyCode': 'نسخ الرمز',
  'admin.coupons.allPlans': 'جميع الخطط',
  'admin.coupons.discount': 'خصم',
  'admin.coupons.days': 'أيام',
  'admin.coupons.months': 'أشهر',
  'admin.coupons.free': 'مجاني',
  'admin.coupons.unlimited': 'غير محدود',
  'admin.coupons.createRegistration': 'إنشاء قسيمة تسجيل',
  'admin.coupons.createTrial': 'إنشاء قسيمة وصول تجريبي',
  'admin.coupons.couponCode': 'رمز القسيمة',
  'admin.coupons.codePlaceholder': 'مثال: NF-7X3K9M',
  'admin.coupons.generateCode': 'توليد رمز جديد',
  'admin.coupons.alertFillRequired': 'يرجى ملء جميع الحقول المطلوبة',
  'admin.coupons.alertSelectExpiry': 'يرجى تحديد تاريخ انتهاء الصلاحية أو تفعيل "صلاحية غير محدودة"',
  'admin.coupons.alertCreateError': 'خطأ في إنشاء القسيمة',
  'admin.coupons.confirmDelete': 'هل أنت متأكد أنك تريد حذف هذه القسيمة؟',
  'admin.coupons.discountPercent': 'الخصم (٪)',
  'admin.coupons.bonusCredits': 'أرصدة إضافية',
  'admin.coupons.freeDuration': 'المدة المجانية',
  'admin.coupons.maxUses': 'الحد الأقصى للاستخدامات',
  'admin.coupons.expiryDate': 'تاريخ الانتهاء',
  'admin.coupons.unlimitedValidity': 'صلاحية غير محدودة',
  'admin.coupons.unlimitedUses': 'استخدامات غير محدودة',
  'admin.coupons.trialCredits': 'أرصدة التجربة',
  'admin.coupons.trialDuration': 'مدة التجربة',
  'admin.coupons.typePlaceholder': 'مثال: Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'المدة',
  'admin.stats.totalUsers': 'إجمالي المستخدمين',
  'admin.stats.monthlyRevenue': 'الإيرادات الشهرية',
  'admin.stats.activeSubscriptions': 'الاشتراكات النشطة',
  'admin.stats.average': 'المتوسط',
  'admin.stats.revenuePerUser': 'الإيرادات لكل مستخدم',
  'admin.stats.grossRevenue': 'إجمالي الإيرادات',
  'admin.stats.net': 'الصافي',
  'admin.stats.netRevenue': 'صافي الإيرادات',
  'admin.stats.churnRate': 'معدل التوقف',
  'admin.stats.planDistribution': 'توزيع الخطط',
  'admin.stats.users': 'مستخدمين',
  'admin.stats.revenueByPlan': 'الإيرادات حسب الخطة',
  'admin.stats.recentActivity': 'النشاط الأخير',
  'admin.stats.activity1': 'قام Thomas Weber بالترقية إلى Builder',
  'admin.stats.activity2': 'مستخدم جديد مسجل',
  'admin.stats.activity3': 'قامت Anna Schmidt بالترقية إلى Pro',
  'admin.stats.hoursAgo2': 'منذ ساعتين',
  'admin.stats.hoursAgo5': 'منذ ٥ ساعات',
  'admin.stats.dayAgo1': 'منذ يوم واحد',
  'admin.stats.couponStats': 'إحصائيات القسائم',
  'admin.stats.totalRedemptions': 'إجمالي مرات الاستخدام',
  'admin.stats.activeCoupons': 'القسائم النشطة',
  'admin.stats.registrationRedemptions': 'استخدامات قسائم التسجيل',
  'admin.stats.trialRedemptions': 'استخدامات قسائم التجربة',
  'admin.stats.couponDistribution': 'توزيع القسائم',
  'admin.stats.registrationCoupons': 'قسائم التسجيل',
  'admin.stats.trialCoupons': 'قسائم التجربة',
  'admin.stats.expiredInactive': 'منتهية/غير نشطة',
  'admin.stats.topCoupons': 'أفضل القسائم من حيث الاستخدام',
  'admin.stats.redemptions': 'استخدامات',
  'admin.stats.noCouponsRedeemed': 'لم يتم استخدام أي قسائم بعد',
  'admin.downgrade.pending': 'قيد الانتظار',
  'admin.downgrade.refunds': 'المبالغ المستردة',
  'admin.downgrade.sectionRequests': 'الطلبات',
  'admin.downgrade.sectionStats': 'الإحصائيات',
  'admin.downgrade.sectionRules': 'القواعد',
  'admin.downgrade.pendingRequests': 'الطلبات المعلقة',
  'admin.downgrade.approvedRequests': 'الطلبات المعتمدة',
  'admin.downgrade.rejectedRequests': 'الطلبات المرفوضة',
  'admin.downgrade.activeRules': 'القواعد النشطة',
  'admin.downgrade.autoRules': 'قواعد التخفيض التلقائي',
  'admin.downgrade.autoRulesDesc': 'أنشئ قواعد تؤدي تلقائياً إلى تخفيض الخطة بناءً على سلوك الاستخدام',
  'admin.downgrade.newRule': 'قاعدة جديدة',
  'admin.downgrade.totalRules': 'إجمالي القواعد',
  'admin.downgrade.triggeredActions': 'الإجراءات التي تم تشغيلها',
  'admin.downgrade.conditionsAnd': 'الشروط (مرتبطة بـ AND)',
  'admin.downgrade.action': 'الإجراء',
  'admin.downgrade.successTitle': 'تم التخفيض بنجاح!',
  'admin.downgrade.successDesc': 'تم تخفيض خطة المستخدم بنجاح وتمت معالجة المبلغ المسترد.',
  'admin.downgrade.closing': 'جاري الإغلاق...',
  'admin.downgrade.title': 'تخفيض خطة المستخدم',
  'admin.downgrade.currentPlan': 'الخطة الحالية',
  'admin.downgrade.spending': 'الإنفاق',
  'admin.downgrade.availablePlans': 'الخطط المتاحة للتخفيض',
  'admin.downgrade.perMonth': 'شهرياً',
  'admin.downgrade.refundCalc': 'حساب المبلغ المسترد',
  'admin.downgrade.currentPlanLabel': 'الخطة الحالية',
  'admin.downgrade.newPlan': 'الخطة الجديدة',
  'admin.downgrade.remainingDays': 'الأيام المتبقية',
  'admin.downgrade.daysOf': '١٥ من ٣٠ يوماً',
  'admin.downgrade.proRataRefund': 'المبلغ المسترد نسبياً',
  'admin.downgrade.importantNote': 'ملاحظة مهمة',
  'admin.downgrade.warningDesc': 'سيتم تنفيذ التخفيض فوراً. سيفقد المستخدم إمكانية الوصول إلى الميزات المميزة وستتم إزالة الأرصدة الزائدة.',
  'admin.downgrade.processing': 'جاري المعالجة...',
  'admin.downgrade.execute': 'تنفيذ التخفيض',
  'admin.downgrade.notification': 'إشعار',
  'admin.downgrade.noNotification': 'بدون إشعار',
  'admin.downgrade.daysPeriod': 'أيام فترة سماح',
  'admin.downgrade.created': 'تم الإنشاء:',
  'admin.downgrade.triggered': 'تم التشغيل',
  'admin.downgrade.noRules': 'لم يتم إنشاء أي قواعد بعد',
  'admin.downgrade.createFirstRule': 'إنشاء القاعدة الأولى',
  'admin.downgrade.editRule': 'تعديل القاعدة',
  'admin.downgrade.createRule': 'إنشاء قاعدة جديدة',
  'admin.downgrade.ruleName': 'اسم القاعدة',
  'admin.downgrade.description': 'الوصف',
  'admin.downgrade.allConditions': 'الشروط (يجب استيفاء جميعها)',
  'admin.downgrade.addCondition': 'إضافة شرط',
  'admin.downgrade.type': 'النوع',
  'admin.downgrade.value': 'القيمة',
  'admin.downgrade.fromPlan': 'من خطة',
  'admin.downgrade.toPlan': 'إلى خطة',
  'admin.condition.inactivity': 'عدم النشاط',
  'admin.condition.creditUsage': 'استخدام الرصيد',
  'admin.condition.loginFrequency': 'تكرار تسجيل الدخول',
  'admin.condition.featureUsage': 'استخدام الميزات',
  'admin.condition.supportTickets': 'تذاكر الدعم',
  'admin.operator.lessThan': 'أقل من',
  'admin.operator.greaterThan': 'أكثر من',
  'admin.operator.equals': 'يساوي',
  'admin.operator.between': 'بين',
  'admin.unit.days': 'أيام',
  'admin.unit.perMonth': 'شهرياً',
  'admin.unit.count': 'عدد',
  'admin.transactions.all': 'جميع المعاملات',
  'admin.transactions.allCards': 'جميع البطاقات',
  'admin.transactions.notFound': 'لم يتم العثور على معاملات',
  'admin.transactions.totalLabel': 'الإجمالي',
  'admin.transactions.transactions': 'معاملات',
  'admin.tips.title': 'نصيحة اليوم',
  'admin.tips.subtitle': 'إنشاء وإدارة النصائح التي تظهر لجميع المستخدمين',
  'admin.tips.active': 'نشط',
  'admin.tips.currentlyShown': 'هذه النصيحة معروضة حالياً لجميع المستخدمين',
  'admin.tips.createNew': 'إنشاء نصيحة جديدة',
  'admin.tips.generating': 'جاري التوليد...',
  'admin.tips.generateAI': 'توليد نصيحة بالذكاء الاصطناعي',
  'admin.tips.titleLabel': 'العنوان',
  'admin.tips.titlePlaceholder': 'مثال: نصيحة اليوم',
  'admin.tips.category': 'الفئة',
  'admin.tips.categoryTip': 'نصيحة',
  'admin.tips.categoryFeature': 'ميزة جديدة',
  'admin.tips.categoryProductivity': 'إنتاجية',
  'admin.tips.categoryUpdate': 'تحديث',
  'admin.tips.content': 'المحتوى',
  'admin.tips.contentPlaceholder': 'اكتب نصيحتك للمستخدمين هنا...',
  'admin.tips.addTip': 'إضافة نصيحة',
  'admin.tips.allTips': 'جميع النصائح',
  'admin.tips.noTips': 'لم يتم إنشاء أي نصائح بعد',
  'admin.tips.noTipsHint': 'انقر على "توليد نصيحة بالذكاء الاصطناعي" للبدء',
  'admin.noData': 'لا توجد بيانات متاحة',
  'admin.range.7d': '٧ أيام',
  'admin.range.30d': '٣٠ يوماً',
  'admin.range.90d': '٩٠ يوماً',
  'admin.range.1y': 'سنة واحدة',
  'admin.actions.saveSettings': 'حفظ الإعدادات',
  'admin.actions.create': 'إنشاء',
  'admin.downgrade.sectionReports': 'التقارير',
  'admin.downgrade.settings': 'إعدادات التخفيض',
  'admin.downgrade.autoApprove': 'الموافقة التلقائية',
  'admin.downgrade.autoApproveDesc': 'الموافقة التلقائية على طلبات التخفيض',
  'admin.downgrade.refundPolicy': 'سياسة الاسترداد',
  'admin.downgrade.prorata': 'استرداد نسبي',
  'admin.downgrade.prorataDesc': 'استرداد نسبي يعتمد على الأيام المتبقية',
  'admin.downgrade.fullRefund': 'استرداد كامل',
  'admin.downgrade.fullRefundDesc': 'استرداد كامل للفرق في السعر',
  'admin.downgrade.noRefund': 'بدون استرداد',
  'admin.downgrade.noRefundDesc': 'تخفيض بدون استرداد',
  'admin.downgrade.daysRemaining15': '(مع ١٥ يوماً متبقية)',
  'admin.downgrade.requestsTitle': 'طلبات التخفيض',
  'admin.downgrade.approvalRate': 'نسبة الموافقة',
  'admin.downgrade.mostCommonTransition': 'الانتقال الأكثر شيوعاً',
  'admin.downgrade.mostCommonReason': 'السبب الأكثر شيوعاً',
  'admin.downgrade.avgProcessingTime': 'متوسط وقت المعالجة',
  'admin.downgrade.avgTimeDesc': 'متوسط الوقت حتى اتخاذ القرار',
  'admin.downgrade.totalRefunds': 'إجمالي المبالغ المستردة',
  'admin.downgrade.pendingRefunds': 'المبالغ المستردة المعلقة',
  'admin.downgrade.summary': 'الملخص',
  'admin.downgrade.total': 'الإجمالي',
  'admin.downgrade.csvDesc': 'لـ Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'تنزيل كـ CSV',
  'admin.downgrade.jsonDesc': 'للمطورين، APIs',
  'admin.downgrade.downloadJSON': 'تنزيل كـ JSON',
  'admin.downgrade.exportInfo': 'يحتوي التصدير على',
  'admin.downgrade.entries': 'إدخالات من الفترة المحددة',
  'admin.downgrade.topReasons': 'أكثر أسباب التخفيض شيوعاً',
  'admin.downgrade.refundHistory': 'سجل المبالغ المستردة',
  'admin.downgrade.noRefunds': 'لا توجد مبالغ مستردة حتى الآن',
  'admin.downgrade.statistics': 'إحصائيات التخفيض',
  'admin.downgrade.requests': 'الطلبات',
  'admin.downgrade.monthlyTrend': 'الاتجاه الشهري',
  'admin.downgrade.planTransitions': 'الانتقالات بين الخطط',
  'admin.downgrade.trend': 'الاتجاه (مقارنة بالشهر السابق)',
  'admin.downgrade.trendDesc': 'قلة التخفيضات = أفضل',
  'admin.coupons.allPlansUniversal': 'جميع الخطط (عالمي)',
  'admin.coupons.onlyStarter': 'مبتدئ فقط',
  'admin.coupons.onlyPro': 'محترف فقط',
  'admin.coupons.onlyBuilder': 'منشئ فقط',
  'admin.coupons.allPlansHint': 'اختر "جميع الخطط" للحصول على قسيمة عالمية',
  'admin.coupons.discountOptional': 'الخصم (٪) (اختياري)',
  'admin.coupons.discountPlaceholder': 'مثال: 50 للحصول على خصم ٥٠٪',
  'admin.coupons.bonusCreditsOptional': 'أرصدة إضافية (اختياري)',
  'admin.coupons.bonusCreditsPlaceholder': 'مثال: 500',
  'admin.coupons.freeDurationOptional': 'المدة المجانية (اختياري)',
  'admin.coupons.durationPlaceholder': 'مثال: 30',
  'admin.coupons.freeDurationHint': 'مثال: ٣٠ يوماً للاستخدام المجاني',
  'admin.coupons.noLimit': 'لا يوجد حد للاستخدام',
  'admin.coupons.noExpiry': 'لا يوجد تاريخ انتهاء',
  'admin.coupons.creditsPlaceholder': 'مثال: 100',
  'admin.coupons.creditsHint': 'عدد الأرصدة للوصول التجريبي',
  'admin.coupons.trialDurationHint': 'مدة صلاحية الوصول التجريبي',
  'admin.coupons.autoCalculated': 'يتم حسابه تلقائياً من مدة التجربة',
  'admin.websiteEditor.title': 'محرر الموقع',
  'admin.websiteEditor.subtitle': 'تحرير جميع أقسام الصفحة الرئيسية',
  'admin.websiteEditor.openPreview': 'فتح المعاينة',
  'admin.websiteEditor.group.structure': 'هيكل الصفحة',
  'admin.websiteEditor.group.design': 'التصميم والتخطيط',
  'admin.websiteEditor.group.settings': 'الإعدادات',
  'admin.websiteEditor.tab.navbar': 'شريط التنقل',
  'admin.websiteEditor.tab.howitworks': 'كيف يعمل',
  'admin.websiteEditor.tab.about': 'من نحن',
  'admin.websiteEditor.tab.pricing': 'الأسعار',
  'admin.websiteEditor.tab.sections': 'الأقسام',
  'admin.websiteEditor.tab.media': 'الوسائط',
  'admin.websiteEditor.tab.chatwidget': 'تحدث معنا',
  'admin.websiteEditor.tab.invoice': 'الفواتير',
  'admin.websiteEditor.tab.legal': 'قانوني',
  'admin.websiteEditor.tab.seo': 'SEO أساسي',
  'admin.websiteEditor.tab.advancedseo': 'SEO متقدم',
  'admin.websiteEditor.tab.versions': 'الإصدارات',
  'admin.hero.title': 'تحرير قسم البطل',
  'admin.hero.subtitle': 'نصوص وأزرار وإحصائيات الصفحة الرئيسية',
  'admin.hero.reset': 'إعادة تعيين',
  'admin.hero.save': 'حفظ',
  'admin.hero.savedMsg': 'تم حفظ بيانات البطل!',
  'admin.hero.badge': 'نص الشارة',
  'admin.hero.headings': 'العناوين الرئيسية',
  'admin.hero.line1White': 'السطر ١ (أبيض)',
  'admin.hero.line2Gold': 'السطر ٢ (ذهبي)',
  'admin.hero.subtitleSection': 'العنوان الفرعي',
  'admin.hero.line1': 'السطر ١',
  'admin.hero.line2': 'السطر ٢',
  'admin.hero.buttons': 'الأزرار',
  'admin.hero.primaryBtn': 'الزر الرئيسي (ذهبي)',
  'admin.hero.secondaryBtn': 'الزر الثانوي (حدود)',
  'admin.hero.stats': 'الإحصائيات',
  'admin.hero.statN': 'إحصائية {{n}}',
  'admin.hero.value': 'القيمة',
  'admin.hero.label': 'التسمية',
  'admin.hero.previewNote': 'ستظهر التغييرات على الصفحة الرئيسية بعد الحفظ. أعد تحميل الصفحة لمعاينة التغييرات.',

  // Idea History
  'history.title': 'سجل الأفكار',
  'history.countLabel': '{{count}} تحليلاً',
  'history.recentLabel': 'تحليلاتك الأخيرة',
  'history.exportAll': 'تصدير الكل',
  'history.metrics.marketSize': 'حجم السوق',
  'history.metrics.competition': 'المنافسة',
  'history.metrics.startingCapital': 'رأس المال الأولي',
  'history.metrics.timeToMarket': 'الوقت حتى السوق',
  'history.metrics.profitPotential': 'إمكانية الربح',
  'history.metrics.scalability': 'قابلية التوسع',
  'history.summary.title': 'الملخص',
  'history.download': 'تنزيل',
  'history.downloadJSON': 'حفظ كـ JSON',
  'history.downloadTXT': 'حفظ كـ TXT',
  'history.downloadPDF': 'حفظ كـ PDF',
  'history.fullAnalysis': 'تحليل كامل',
  'history.searchPlaceholder': 'البحث بالعنوان أو العلامات...',
  'history.filterAll': 'جميع التقييمات',
  'history.loading': 'جاري تحميل التحليلات...',
  'history.noResults': 'لم يتم العثور على نتائج',
  'history.empty': 'لا توجد تحليلات بعد',
  'history.emptyHint': 'ابدأ تحليلاً في مساعد الذكاء الاصطناعي',
  'history.delete': 'حذف',
  'history.cancel': 'إلغاء',
  'history.deleteModalTitle': 'هل تريد حذف التحليل؟',
  'history.deleteModalDesc': 'سيتم حذف "{{title}}" بشكل دائم.',
  'history.errorLoading': 'خطأ في تحميل التحليلات',
  'history.deleteSuccess': 'تم حذف التحليل بنجاح',
  'history.deleteError': 'خطأ في حذف التحليل',
  'history.jsonExported': 'تم تصدير JSON',
  'history.txtExported': 'تم تصدير TXT',
  'history.allExported': 'تم تصدير {{count}} فكرة',
  'history.analysisHeader': 'تحليل الفكرة',
  'history.titleLabel': 'العنوان',
  'history.ratingLabel': 'التقييم',
  'history.dateLabel': 'التاريخ',
  'history.creditsLabel': 'الأرصدة',
  'history.analysisSection': 'التحليل',

  // Overview
  'overview.title': 'نظرة عامة',
  'overview.last24h': 'آخر ٢٤ ساعة',
  'overview.analysesToday': 'التحليلات اليوم',
  'overview.totalAnalyses': 'إجمالي التحليلات',
  'overview.successRate': 'نسبة النجاح',
  'overview.topRatings': 'أفضل التقييمات',
  'overview.recentActivity': 'النشاط الأخير',
  'overview.viewAll': 'عرض الكل',
  'overview.quickAccess': 'وصول سريع',
  'overview.quick.newAnalysis': 'بدء تحليل جديد',
  'overview.quick.newAnalysisDesc': 'بدء تحليل مجال جديد مدعوم بالذكاء الاصطناعي',
  'overview.quick.myAnalyses': 'تحليلاتي',
  'overview.quick.myAnalysesDesc': 'عرض جميع التحليلات السابقة',
  'overview.quick.buyCredits': 'شراء أرصدة',
  'overview.quick.buyCreditsDesc': 'المزيد من الأرصدة لمزيد من التحليلات',
  'overview.quick.settings': 'الإعدادات',
  'overview.quick.settingsDesc': 'تخصيص الملف الشخصي والتفضيلات',
  'overview.unlimitedCredits': 'أرصدة غير محدودة متاحة',
  'overview.creditsAvailable': 'رصيد متوفر',
  'overview.upgradePlan': 'ترقية الخطة',
  'overview.buyCredits': 'شراء أرصدة',
  'overview.creditUsage': 'استخدام الرصيد هذا الشهر',
  'overview.available': 'متوفر',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'الترقيات',
  'admin.transactions.downgrades': 'التخفيضات',
  'admin.transactions.visa': 'فيزا',
  'admin.transactions.mastercard': 'ماستركارد',
  'admin.transactions.amex': 'أمريكان إكسبريس',

  'admin.users.grantFreeSuccess': '{{name}} لديه الآن {{months}} شهر(شهور) من خطة {{plan}} المجانية',
  'admin.users.blockSuccess': 'تم حظر {{name}}',
  'admin.users.unblockSuccess': 'تم إلغاء حظر {{name}}',
  'admin.users.removeFreeSuccess': 'تمت إزالة الحالة المجانية لـ {{name}}',

  'admin.downgrade.plans.builder': 'منشئ',
  'admin.downgrade.plans.pro': 'محترف',
  'admin.downgrade.plans.starter': 'مبتدئ',
  'admin.downgrade.plans.free': 'مجاني',

  'admin.unit.percent': '٪',

  'admin.tips.discoverNewFeature': 'اكتشف ميزة جديدة',
  'admin.tips.productivityBoost': 'تعزيز الإنتاجية',
  'admin.tips.importantUpdate': 'تحديث مهم',
  'admin.tips.tipOfDay': 'نصيحة اليوم',

  'admin.actions.activate': 'تفعيل',
  'admin.actions.deactivate': 'إلغاء التفعيل',
  'admin.websiteEditor.tab.features': 'الميزات',
  'admin.websiteEditor.tab.testimonials': 'شهادات العملاء',
  'admin.websiteEditor.tab.faq': 'الأسئلة الشائعة',
  'admin.websiteEditor.tab.cta': 'الحث على اتخاذ إجراء',
  'admin.websiteEditor.tab.footer': 'تذييل الصفحة',
  'admin.websiteEditor.tab.design': 'التصميم',
  'admin.websiteEditor.tab.customcode': 'رمز مخصص',
  'admin.websiteEditor.tab.socials': 'وسائل التواصل الاجتماعي',
  'admin.websiteEditor.tab.importexport': 'استيراد/تصدير',

  // --- AI Settings Editor ---
  'admin.ai.title': 'إعدادات مساعد الذكاء الاصطناعي',
  'admin.ai.subtitle': 'تكوين السلوك والأسلوب وعمق التحليل',
  'admin.ai.smartWeightingActive': 'الترجيح الذكي نشط',
  'admin.ai.smartWeightingDesc': 'يجمع الذكاء الاصطناعي تلقائياً جميع وجهات النظر بترجيح ذكي. مع وجود إعدادات مسبقة متعددة، يتم ترجيح الإعداد الأول بشكل أكبر (الإعداد الأساسي). يمكنك أيضاً تعديل الترجيح يدوياً.',
  'admin.ai.modelTitle': 'نموذج IdeaVerdict AI',
  'admin.ai.modelSubtitle': 'اختر محرك الذكاء الاصطناعي لجميع تحليلات المستخدمين',
  'admin.ai.activeModel': 'النموذج النشط:',
  'admin.ai.activeModelDesc': 'يتلقى جميع المستخدمين ردوداً من هذا النموذج.',
  'admin.ai.recommendations': 'توصيات للحصول على أفضل النتائج',
  'admin.ai.new': 'جديد',
  'admin.ai.recommendationsDesc': 'تركيبات الإعدادات المسبقة المثبتة للحصول على أفضل جودة تحليل',
  'admin.ai.recommendationsInfo': 'تم اختبار هذه التركيبات وتقدم أفضل النتائج. انقر على أي توصية لتطبيقها مباشرة.',
  'admin.ai.active': 'نشط',
  'admin.ai.apply': 'تطبيق',
  'admin.ai.avoid': 'تجنب',
  'admin.ai.excellentQuality': 'جودة ممتازة',
  'admin.ai.goodQuality': 'جودة جيدة',
  'admin.ai.poorQuality': 'جودة مخففة - غير موصى به',
  'admin.ai.proTips': 'نصائح احترافية',
  'admin.ai.tip1Title': 'إعدادان مسبقان هما الأمثل:',
  'admin.ai.tip1Desc': 'منظور واضح دون تخفيف',
  'admin.ai.tip2Title': 'الإعداد الأساسي مهم:',
  'admin.ai.tip2Desc': 'الإعداد المسبق الأول له التأثير الأكبر',
  'admin.ai.tip3Title': 'تجنب الأضداد:',
  'admin.ai.tip3Desc': '"EXTREME" + "Creative" = متناقض',
  'admin.ai.tip4Title': 'الحد الأقصى ٣ إعدادات مسبقة:',
  'admin.ai.tip4Desc': 'مع ٤+ إعدادات مسبقة تصبح النتيجة عامة جداً',
  'admin.ai.warningManyPresets': 'تحذير: إعدادات مسبقة كثيرة',
  'admin.ai.warningManyPresetsDesc': 'لديك {{count}} إعداداً مسبقاً محدداً. هذا قد يخفف النتيجة.',
  'admin.ai.warningRecommend': 'مُوصى به: بحد أقصى ٢-٣ إعدادات مسبقة',
  'admin.ai.forOptimalResults': 'للحصول على أفضل النتائج.',
  'admin.ai.presets': 'الإعدادات المسبقة',
  'admin.ai.multiSelect': '(اختيار متعدد ممكن)',
  'admin.ai.presetsDesc': 'اختر واحداً أو أكثر من الإعدادات المسبقة. الإعداد المسبق الأول هو الإعداد الأساسي ذو الترجيح الأعلى.',
  'admin.ai.primaryPreset': 'الإعداد الأساسي',
  'admin.ai.weightControl': 'التحكم في الترجيح',
  'admin.ai.weightControlDesc': 'اضبط مدى تأثير كل إعداد مسبق على التحليل',
  'admin.ai.manual': 'يدوي',
  'admin.ai.automatic': 'تلقائي',
  'admin.ai.autoWeightingActive': 'الترجيح التلقائي نشط:',
  'admin.ai.autoWeightingDesc': 'يتم تحسين الترجيح تلقائياً بناءً على عدد الإعدادات المسبقة.',
  'admin.ai.primary': 'أساسي',
  'admin.ai.totalWeight': 'الإجمالي',
  'admin.ai.shouldBe100': 'يجب أن يكون ١٠٠٪',
  'admin.ai.normalize': 'تطبيع',
  'admin.ai.combinedSettings': 'الإعدادات المدمجة',
  'admin.ai.presetsCount': 'إعدادات مسبقة',
  'admin.ai.strictness': 'الحزم',
  'admin.ai.realism': 'الواقعية',
  'admin.ai.creativity': 'الإبداع',
  'admin.ai.detailLevel': 'مستوى التفاصيل',
  'admin.ai.customInstructions': 'تعليمات مخصصة',
  'admin.ai.customInstructionsDesc': 'تعليمات إضافية يتم دمجها مع الإعدادات المسبقة',
  'admin.ai.customInstructionsPlaceholder': 'مثال: "ركز على سوق DACH"، "استخدم دائماً أرقاماً محددة"، "قارن مع المنافسين الحاليين"، "أجب دائماً بأمثلة"...',
  'admin.ai.customInstructionsHint': 'يتم دمج هذه التعليمات تلقائياً مع الإعدادات المسبقة المحددة.',
  'admin.ai.manualFinetuning': 'ضبط دقيق يدوي',
  'admin.ai.manualFinetuningHint': '(اختياري، يتجاوز قيم الإعدادات المسبقة)',
  'admin.ai.manualFinetuningDesc': 'اضبط القيم المدمجة يدوياً إذا كنت تريد تحسين شيء ما.',
  'admin.ai.tone': 'النبرة',
  'admin.ai.mild': 'معتدل',
  'admin.ai.strict': 'صارم',
  'admin.ai.creative': 'مبدع',
  'admin.ai.realistic': 'واقعي',
  'admin.ai.conservative': 'محافظ',
  'admin.ai.compact': 'مدمج',
  'admin.ai.detailed': 'مفصل',
  'admin.ai.responseLength': 'طول الرد',
  'admin.ai.short': 'قصير ومختصر',
  'admin.ai.medium': 'متوسط',
  'admin.ai.long': 'مفصل',
  'admin.ai.focusAreas': 'مجالات التركيز في التحليل',
  'admin.ai.autoRating': 'تقييم تلقائي',
  'admin.ai.autoRatingDesc': 'كل تحليل يحصل تلقائياً على تقييم (جيد/متوسط/سيئ)',
  'admin.ai.showSources': 'عرض المصادر',
  'admin.ai.showSourcesDesc': 'مراجع لمصادر البيانات وبيانات السوق في الردود',
  'admin.ai.hidePreview': 'إخفاء المعاينة',
  'admin.ai.showPreview': 'إظهار المعاينة',
  'admin.ai.aiBehavior': 'سلوك الذكاء الاصطناعي',
  'admin.ai.length': 'الطول',
  'admin.ai.liveExample': 'مثال مباشر',
  'admin.ai.testSettings': 'اختبار إعداداتك',
  'admin.ai.selectExampleQuestion': 'اختر سؤالاً مثالياً:',
  'admin.ai.userAsks': 'يسأل المستخدم:',
  'admin.ai.generating': 'يقوم الذكاء الاصطناعي بإنشاء رد...',
  'admin.ai.generateExample': 'إنشاء رد مثال',
  'admin.ai.aiResponds': 'يجيب مساعد الذكاء الاصطناعي:',
  'admin.ai.generateHint': 'انقر على "إنشاء رد مثال" لترى كيف يجيب الذكاء الاصطناعي باستخدام إعداداتك.',
  'admin.ai.reset': 'إعادة تعيين',
  'admin.ai.saved': 'تم الحفظ!',
  'admin.ai.saveSettings': 'حفظ الإعدادات',

  // --- Table headers ---
  'admin.coupons.code': 'الرمز',
  'admin.coupons.credits': 'الأرصدة',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'تحليل متوازن بجودة عالية. الخيار الأفضل لمعظم تقييمات المجالات والتحقق من صحة الأفكار.',
  'admin.ai.model.preciseAnalyses': 'تحليلات دقيقة',
  'admin.ai.model.bestBalance': 'أفضل توازن',
  'admin.ai.model.recommended': 'موصى به',
  'admin.ai.model.fastDesc': 'ردود فائقة السرعة لفحوصات المجالات السريعة والعصف الذهني والتقييمات الأولية. مثالي عندما تكون السرعة مهمة.',
  'admin.ai.model.fast': 'سريع',
  'admin.ai.model.fastestResponses': 'أسرع الردود',
  'admin.ai.model.thinkingDesc': 'تحليل عميق بتفكير منطقي متقدم. لتحليلات السوق المعقدة والتقييمات النقدية والتخطيط الاستراتيجي.',
  'admin.ai.model.deepestAnalysis': 'أعمق تحليل',
  'admin.ai.model.logicalThinking': 'تفكير منطقي',
  'admin.ai.model.strategy': 'استراتيجي',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'تحليل صارم',
  'admin.ai.preset.strict.desc': 'نقدي، قائم على الحقائق، بدون تجميل. يكشف نقاط الضعف بلا رحمة.',
  'admin.ai.preset.extreme.name': 'تحليل EXTREME',
  'admin.ai.preset.extreme.desc': 'أقصى درجات الصرامة، نقد لا يرحم، تركيز على أسوأ السيناريوهات. فقط لفحوصات الواقع القاسية.',
  'admin.ai.preset.professional.name': 'مهني',
  'admin.ai.preset.professional.desc': 'موضوعي، منظم، متوازن. مثل مستشار أعمال متمرس.',
  'admin.ai.preset.realistic.name': 'واقعي',
  'admin.ai.preset.realistic.desc': 'صادق وعملي. التركيز على التنفيذ الممكن وبيانات السوق الحقيقية.',
  'admin.ai.preset.creative.name': 'مبدع ومحفز',
  'admin.ai.preset.creative.desc': 'ملهم، غني بالأفكار، إيجابي. يجد الفرص والمسارات غير التقليدية.',
  'admin.ai.preset.balanced.name': 'متوازن',
  'admin.ai.preset.balanced.desc': 'مزيج جيد من النقد والتحفيز. الوضع الافتراضي.',
  'admin.ai.preset.investor.name': 'منظور المستثمر',
  'admin.ai.preset.investor.desc': 'مثل صاحب رأس مال مغامر. التركيز على التوسع والعائد على الاستثمار واستراتيجية الخروج.',
  'admin.ai.preset.startup-coach.name': 'مدرب الشركات الناشئة',
  'admin.ai.preset.startup-coach.desc': 'مرشد عملي للمؤسسين. التركيز على التنفيذ السريع والحد الأدنى من المنتج القابل للتطبيق.',
  'admin.ai.preset.market-researcher.name': 'باحث سوق',
  'admin.ai.preset.market-researcher.desc': 'مدفوع بالبيانات وتحليلي. تحليل سوق ومنافسة عميق.',
  'admin.ai.preset.risk-analyst.name': 'محلل مخاطر',
  'admin.ai.preset.risk-analyst.desc': 'التركيز على المخاطر وأسوأ السيناريوهات. للتخطيط الواقعي.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'تحليل السوق',
  'admin.ai.focus.wettbewerb': 'المنافسة',
  'admin.ai.focus.monetarisierung': 'تحقيق الدخل',
  'admin.ai.focus.risiken': 'المخاطر',
  'admin.ai.focus.finanzen': 'المالية',
  'admin.ai.focus.skalierung': 'التوسع',
  'admin.ai.focus.innovation': 'الابتكار',
  'admin.ai.focus.trends': 'الاتجاهات',
  'admin.ai.focus.differenzierung': 'التميز',
  'admin.ai.focus.umsetzung': 'التنفيذ',
  'admin.ai.focus.zielgruppe': 'الجمهور المستهدف',
  'admin.ai.focus.marketing': 'التسويق',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'مباشر وحاد',
  'admin.ai.tone.professionell': 'مهني وموضوعي',
  'admin.ai.tone.ehrlich': 'صادق وعملي',
  'admin.ai.tone.motivierend': 'محفز وإيجابي',
  'admin.ai.tone.freundlich': 'ودود وداعم',
  'admin.ai.tone.akademisch': 'أكاديمي وتحليلي',

  // --- Example Questions ---
  'admin.ai.question.niche': 'أي مجال مربح توصي به؟',
  'admin.ai.question.evaluate': 'قيم فكرتي: تطبيق لأصحاب الكلاب',
  'admin.ai.question.trends': 'ما هي الاتجاهات التي لديها إمكانية حالياً؟',
  'admin.ai.question.sharpen': 'كيف يمكنني شحذ مجالي؟',

  'admin.ai.rec.bestCombination.title': '🏆 أفضل تركيبة (إعدادان مسبقان)',
  'admin.ai.rec.bestCombination.desc': 'نقدي لكن بنّاء، مع خطوات عمل ملموسة',
  'admin.ai.rec.bestCombination.useCase': 'موصى به لمعظم التحليلات',

  'admin.ai.rec.balancedThree.title': '⚖️ متوازن (٣ إعدادات مسبقة)',
  'admin.ai.rec.balancedThree.desc': 'مهني وواقعي وصديق للمستثمرين',
  'admin.ai.rec.balancedThree.useCase': 'للتحليلات التجارية الشاملة',

  'admin.ai.rec.creativeDriven.title': '💡 مبدع ومحفز (إعدادان مسبقان)',
  'admin.ai.rec.creativeDriven.desc': 'ملهم مع نصائح تنفيذية عملية',
  'admin.ai.rec.creativeDriven.useCase': 'لتوليد الأفكار والعصف الذهني',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'فتح القائمة',
  'header.home': 'الرئيسية',
  'header.notifications': 'الإشعارات',
  'header.settings': 'الإعدادات',
  'header.profile': 'الملف الشخصي',
  'sidebar.collapse': 'طي الشريط الجانبي',
  'sidebar.expand': 'توسيع الشريط الجانبي',
  'sidebar.close': 'إغلاق القائمة',
  'sidebar.plan': 'الخطة',
  'sidebar.backToWebsite': 'العودة إلى الموقع',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'مرحباً بعودتك',
  'overview.greetingSub': 'إليك ما يحدث على مكتب الأحكام الخاص بك.',
  'overview.heroCta': 'حكم جديد',
  'overview.currentPlan': 'الخطة الحالية',
  'overview.creditsLabel': 'رصيد',
  'overview.usedThisCycle': 'مستخدم في هذه الدورة',
  'overview.resetsOn': 'إعادة التعيين في',
  'overview.unlimitedTitle': 'غير محدود',
  'overview.builderPerk': 'لديك وصول Builder كامل — بدون حدود.',
  'overview.runOne': 'تشغيل حكم',
  'overview.lastVerdicts': 'آخر 5 أحكام',
  'overview.noActivity': 'لا توجد أحكام بعد — ابدأ تحليلك الأول',
  'overview.tipTitle': 'نصيحة',
  'overview.tipBody': 'مرر فكرة عبر لغتين — إذا لطف الحكم في إحداهما، فإن افتراضاتك محلية وليست عالمية.',
  'onboard.skip': "تخطي",
  'onboard.cta.next': "التالي",
  'onboard.cta.start': "ابدأ",
  'onboard.s1.title': "مرحباً بك في IdeaVerdict",
  'onboard.s1.body': "حكم ذكاء اصطناعي على فكرتك التجارية — قبل أن تبنيها.",
  'onboard.s2.title': "أحكام صادقة بلا مجاملة",
  'onboard.s2.body': "لا ضجيج، لا تملق. بيانات سوق حقيقية، منافسون حقيقيون، مخاطر حقيقية.",
  'onboard.s3.title': "تقارير بنّاء بصيغة PDF",
  'onboard.s3.body': "أنشئ تقارير من 25-75 صفحة تشمل البنية التقنية الكاملة، النماذج المالية واستراتيجية الدخول للسوق.",
  'onboard.s4.title': "جاهزون حين تكون جاهزاً",
  'onboard.s4.body': "سجّل واحصل على أول حكم في أقل من دقيقة.",
  'builderReport.title': "جارٍ إعداد تقرير البنّاء",
  'builderReport.subtitle': "تحليل شامل + إحاطة للمطورين — يُحمَّل كملف PDF عند الجاهزية.",
  'builderReport.idea': "فكرتك",
  'builderReport.ideaPlaceholder': "صف فكرتك التجارية (أو اتركها فارغة لاستخدام آخر فكرة ناقشتها)…",
  'builderReport.cta': "إنشاء التقرير",
  'builderReport.credits': "رصيد",
  'builderReport.deductedNow': "يُخصم عند النجاح",
  'builderReport.dontClose': "لا تُغلق هذه النافذة — قد يستغرق الإنشاء 30-90 ثانية.",
  'builderReport.done': "تم تنزيل الـ PDF — تفقّد مجلد التنزيلات.",
  'builderReport.failed': "فشل في الإنشاء",
  'builderReport.close': "إغلاق",
  'builderReport.cancel': "إلغاء",
  'builderReport.running': "جارٍ الإنشاء…",
  'builderReport.retry': "حاول مجدداً",
  'builderReport.unknownError': "فشل الإنشاء. سيتم استرداد رصيدك.",
  'builderReport.signInRequired': "يجب تسجيل الدخول لإنشاء تقرير.",
  'builderReport.ideaRequired': "صف فكرتك ليكون لدى الذكاء الاصطناعي ما يحلله.",
  'builderReport.fromChat': "من محادثتك الحالية",
  'builderReport.noIdeaDetected': "نستخدم الفكرة التي كنا نناقشها.",
  'builderReport.contextHint': "سيستخدم الذكاء الاصطناعي كل ما في هذه المحادثة — لن نخترع فكرة جديدة.",
  'builderReport.step.core': "إنشاء التحليل الأساسي",
  'builderReport.step.market': "إضافة تحليل سوق موسّع",
  'builderReport.step.tech': "إضافة البنية التقنية",
  'builderReport.step.financials': "إضافة النماذج المالية",
  'builderReport.step.compet': "إضافة الذكاء التنافسي",
  'builderReport.step.gtm': "إضافة استراتيجية الدخول للسوق",
  'builderReport.step.deepdive': "إضافة تعمّق صناعي",
  'builderReport.step.pdf': "تجميع الـ PDF…",
  'briefing.title': "جارٍ إعداد إحاطة المطوّر",
  'briefing.subtitle': "إحاطة تقنية من 11 قسماً — تُحمَّل كملف PDF عند الجاهزية.",
  'briefing.ideaPlaceholder': "صف فكرتك التجارية (أو اتركها فارغة لاستخدام آخر فكرة ناقشتها)…",
  'briefing.cta': "إنشاء الإحاطة",
  'briefing.step.core': "إنشاء إحاطة المطوّر",
  'briefing.step.pdf': "تجميع الـ PDF…",
  'pricing.gold.name': "ذهبي",
  'pricing.gold.description': "رصيد أكثر + تقارير من 50 صفحة",
  'pricing.gold.credits': "12,500 رصيد شهرياً",
  'pricing.platinum.name': "بلاتيني",
  'pricing.platinum.description': "الفئة القصوى + تقارير من 75 صفحة",
  'pricing.platinum.credits': "15,000 رصيد شهرياً",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "ar" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "لم يتبقَّ سوى {{count}} رصيد!",
  'trial.upgradeNow': "رقّ الآن",
  'trial.upgradeNowArrow': "رقّ الآن ←",
  'trial.creditsExhausted': "نفد الرصيد",
  'trial.upgradeForUnlimited': "رقّ للاستخدام غير المحدود",
  'trial.noCreditsPlaceholder': "لا رصيد متبقٍ…",
  'hero.badgeHonest': "ذكاء اصطناعي صادق وغير منحاز",
  'hero.badge60sec': "الحكم في 60 ثانية",
  'hero.badge20Lang': "أكثر من 20 لغة",
  'hero.widget.label': "حكم الفكرة",
  'hero.widget.passed': "نجحت",
  'hero.widget.demoIdea': "مدرّس ذكاء اصطناعي لطلاب الطب",
  'hero.widget.market': "السوق",
  'hero.widget.demand': "الطلب",
  'hero.widget.competition': "المنافسة",
  'hero.widget.verdictReady': "الحكم جاهز · 47 ثانية",
  'hero.widget.riskFlagged': "تم رصد مخاطرة",
  'hero.widget.crowdedMarket': "سوق مزدحم · 4 لاعبين رئيسيين",
  'hero.widget.suggestedPivot': "تحوّل مقترح",
  'hero.widget.nicheBySpecialty': "تخصص حسب المجال",
  'hero.widget.feasibilityGain': "+38% جدوى",
  'hero.widget.analysisDone': "انتهى التحليل",
  'hero.widget.metrics56': "5 من 6 مؤشرات",
  'hero.stats.verdictSpeed': "سرعة الحكم",
  'cta.badge': "الحكم في 60 ثانية",
  'cta.subtitleEnd': "بلا تخمين.",
  'cta.signinPrompt': "لديك حساب؟ سجّل الدخول",
  'cta.trustTrial': "تجربة مجانية 7 أيام",
  'cta.trustNoCard': "بدون بطاقة",
  'cta.trustCancel': "إلغاء في أي وقت",
  'footer.themeLabel': "المظهر:",
  'footer.lightMode': "الوضع الفاتح",
  'footer.darkMode': "الوضع الداكن",
  'footer.sectionProduct': "المنتج",
  'footer.sectionLegal': "القانوني",
  'nav.switchLight': "التبديل للوضع الفاتح",
  'nav.switchDark': "التبديل للوضع الداكن",
  'features.badge': "لماذا IdeaVerdict",
  'features.mainFeatureLabel': "العنوان الرئيسي",
  'chatError.planRestriction': "تتطلب هذه الميزة خطة أعلى.",
  'chatError.creditDeduction': "فشلت معالجة الدفع. حاول مرة أخرى.",
  'chatError.aiService': "خدمة الذكاء الاصطناعي غير متاحة مؤقتاً. لم يتم خصم رصيدك. حاول مرة أخرى.",
  'chatError.parseError': "تم استلام تنسيق استجابة غير متوقع. حاول مرة أخرى.",
  'chatError.sessionExpired': "انتهت جلستك. يرجى تسجيل الدخول مرة أخرى.",
  'chatError.timeout': "استغرق الطلب وقتاً طويلاً جداً. حاول مرة أخرى.",
  'chatError.generic': "فشل في الحصول على رد. حاول مرة أخرى.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "ar" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "لم يتبقَّ سوى {{count}} رصيد!",
  'trial.outOfCredits': "نفد الرصيد",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "سوق مزدحم · 4 لاعبين رئيسيين",
  'hero.widget.nicheBySpec': "تخصص حسب المجال",
  'hero.widget.feasibilityUp': "+38% جدوى",
  'hero.widget.fiveOfSix': "5 من 6 مؤشرات",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "Builder Report من 25 صفحة",
  'pricing.gold.report': "Builder Report من 50 صفحة",
  'pricing.platinum.report': "Builder Report من 75 صفحة",
  'auth.bestValue': "أفضل قيمة",
  'auth.elite': "النخبة",
  'builderReport.friendlyError': "لم نتمكن من إنهاء تقريرك هذه المرة. لم يتم خصم رصيدك — يرجى المحاولة مرة أخرى بعد لحظة.",
  'builderReport.persistHint': "إذا استمرت المشكلة، يرجى التواصل مع support@ideaverdict.ai.",
};
